export const IconArrowLeft = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.274905 6.91602L5.5874 12.2285C5.95459 12.5957 6.54834 12.5957 6.91162 12.2285L7.79444 11.3457C8.16162 10.9785 8.16162 10.3848 7.79444 10.0215L4.03272 6.25195L7.79834 2.48633C8.16553 2.11914 8.16553 1.52539 7.79834 1.16211L6.91553 0.275392C6.54834 -0.0917942 5.95459 -0.0917944 5.59131 0.275392L0.278811 5.58789C-0.0922825 5.95508 -0.0922825 6.54883 0.274905 6.91602Z"
      fill={color}
    />
  </svg>
);

export const IconArrowRight = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.76172 5.58789L3.44922 0.275391C3.08203 -0.0917969 2.48828 -0.0917969 2.125 0.275391L1.24219 1.1582C0.874998 1.52539 0.874998 2.11914 1.24219 2.48242L5.0039 6.25195L1.23828 10.0176C0.871092 10.3848 0.871092 10.9785 1.23828 11.3418L2.12109 12.2285C2.48828 12.5957 3.08203 12.5957 3.44531 12.2285L8.75781 6.91602C9.1289 6.54883 9.1289 5.95508 8.76172 5.58789Z"
      fill={color}
    />
  </svg>
);

export const IconExternalLink = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="m20.749 12l1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466a.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104l1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001a1.5 1.5 0 0 1 .001-3.001zm.3 9.6l-1.6-1.199l6-8l1.6 1.199l-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001a1.5 1.5 0 0 1-.001 3.001z"
    />
  </svg>
);

export const IconVerify = ({ color = '#85819C', size = 13 }: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#85819C" />
    <path
      d="M6.71715 10.8822L4.11715 8.26721C3.96095 8.11011 3.96095 7.85539 4.11715 7.69827L4.68282 7.12933C4.83903 6.97221 5.09231 6.97221 5.24851 7.12933L7 8.89087L10.7515 5.11783C10.9077 4.96072 11.161 4.96072 11.3172 5.11783L11.8828 5.68677C12.0391 5.84387 12.0391 6.09859 11.8828 6.25571L7.28284 10.8822C7.12662 11.0393 6.87336 11.0393 6.71715 10.8822V10.8822Z"
      fill="white"
    />
  </svg>
);

export const IconHome = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5853 9.83945L11.0611 0.818743L10.4898 0.213781C10.3596 0.0768506 10.1835 0 10 0C9.81654 0 9.64048 0.0768506 9.5103 0.213781L0.414826 9.83945C0.281429 9.98014 0.176004 10.1477 0.104772 10.3322C0.0335409 10.5168 -0.002053 10.7146 9.14394e-05 10.9139C0.00891557 11.7361 0.655283 12.3924 1.43181 12.3924H2.36937V20H17.6307V12.3924H18.5881C18.9654 12.3924 19.3205 12.2359 19.5875 11.9533C19.7189 11.8146 19.823 11.6496 19.8938 11.468C19.9647 11.2864 20.0007 11.0917 20 10.8952C20 10.4981 19.8522 10.1221 19.5853 9.83945ZM11.2354 18.3183H8.76466V13.5533H11.2354V18.3183ZM16.0424 10.7107V18.3183H12.6473V12.9927C12.6473 12.4765 12.2524 12.0584 11.7649 12.0584H8.23521C7.74768 12.0584 7.3528 12.4765 7.3528 12.9927V18.3183H3.95771V10.7107H1.83992L10.0022 2.07538L10.5118 2.61494L18.1624 10.7107H16.0424Z"
      fill={color}
    />
  </svg>
);

export const IconDescubra = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM10 18.3036C5.41518 18.3036 1.69643 14.5848 1.69643 10C1.69643 5.41518 5.41518 1.69643 10 1.69643C14.5848 1.69643 18.3036 5.41518 18.3036 10C18.3036 14.5848 14.5848 18.3036 10 18.3036ZM14.4286 5.17634C14.3412 5.14218 14.2479 5.12558 14.154 5.1275C14.0602 5.12941 13.9676 5.1498 13.8817 5.1875L7.83259 7.83482L5.1875 13.8839C5.10714 14.067 5.10714 14.2746 5.1875 14.4576C5.26339 14.6317 5.40402 14.7679 5.58259 14.8371C5.66741 14.8705 5.75446 14.8862 5.84375 14.8862C5.94196 14.8862 6.03795 14.8661 6.12946 14.8259L12.1786 12.1786L14.8237 6.12946C14.8623 6.04118 14.8826 5.94602 14.8835 5.84967C14.8845 5.75333 14.8659 5.65779 14.829 5.56879C14.7921 5.47978 14.7377 5.39915 14.6688 5.33171C14.6 5.26427 14.5183 5.21143 14.4286 5.17634ZM11.4464 10.5L12.0312 11.0848L11.0848 12.0312L10.5 11.4464L7.05357 12.9554L8.56027 9.50893L7.99107 8.9375L8.9375 7.99107L9.5067 8.56027L12.9554 7.05357L11.4464 10.5ZM8.9375 7.99107L7.99107 8.9375L8.56027 9.50893L10.5 11.4464L11.0848 12.0312L12.0312 11.0848L11.4464 10.5L9.50893 8.56027L8.9375 7.99107Z"
      fill={color}
    />
  </svg>
);

export const IconFavoritos = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5161 3.67173C19.2058 2.95322 18.7584 2.30211 18.1988 1.75485C17.6389 1.20596 16.9787 0.769759 16.2542 0.469978C15.5029 0.157889 14.6971 -0.0018562 13.8835 1.62724e-05C12.7422 1.62724e-05 11.6286 0.312552 10.6609 0.902897C10.4294 1.04412 10.2095 1.19923 10.0011 1.36823C9.79279 1.19923 9.57286 1.04412 9.34135 0.902897C8.37364 0.312552 7.26009 1.62724e-05 6.11876 1.62724e-05C5.2969 1.62724e-05 4.50052 0.157442 3.74811 0.469978C3.02118 0.770938 2.36601 1.20386 1.80345 1.75485C1.24319 2.30149 0.795642 2.95275 0.486167 3.67173C0.164371 4.4195 0 5.21358 0 6.0308C0 6.80172 0.157426 7.60505 0.469961 8.42228C0.731565 9.10523 1.10661 9.81364 1.58583 10.529C2.34518 11.6611 3.38928 12.8418 4.68572 14.0387C6.83412 16.0227 8.96167 17.3932 9.05196 17.4488L9.60064 17.8007C9.84372 17.9558 10.1563 17.9558 10.3993 17.8007L10.948 17.4488C11.0383 17.3909 13.1635 16.0227 15.3143 14.0387C16.6107 12.8418 17.6548 11.6611 18.4141 10.529C18.8934 9.81364 19.2707 9.10523 19.53 8.42228C19.8426 7.60505 20 6.80172 20 6.0308C20.0023 5.21358 19.8379 4.4195 19.5161 3.67173ZM10.0011 15.9694C10.0011 15.9694 1.75946 10.6887 1.75946 6.0308C1.75946 3.67173 3.71107 1.75948 6.11876 1.75948C7.81108 1.75948 9.27884 2.70403 10.0011 4.08382C10.7235 2.70403 12.1912 1.75948 13.8835 1.75948C16.2912 1.75948 18.2428 3.67173 18.2428 6.0308C18.2428 10.6887 10.0011 15.9694 10.0011 15.9694Z"
      fill={color}
    />
  </svg>
);

export const IconOlho = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8675 6.88572C17.6931 2.30518 14.4062 0 9.99999 0C5.59148 0 2.30689 2.30518 0.132451 6.88801C0.0452335 7.0727 0 7.2744 0 7.47864C0 7.68289 0.0452335 7.88459 0.132451 8.06927C2.30689 12.6498 5.59378 14.955 9.99999 14.955C14.4085 14.955 17.6931 12.6498 19.8675 8.06698C20.0442 7.6954 20.0442 7.26418 19.8675 6.88572ZM9.99999 13.3035C6.30024 13.3035 3.59137 11.4273 1.68071 7.4775C3.59137 3.52773 6.30024 1.65147 9.99999 1.65147C13.6997 1.65147 16.4086 3.52773 18.3193 7.4775C16.4109 11.4273 13.702 13.3035 9.99999 13.3035ZM9.90825 3.44057C7.67876 3.44057 5.87132 5.24801 5.87132 7.4775C5.87132 9.70698 7.67876 11.5144 9.90825 11.5144C12.1377 11.5144 13.9452 9.70698 13.9452 7.4775C13.9452 5.24801 12.1377 3.44057 9.90825 3.44057ZM9.90825 10.0465C8.48844 10.0465 7.33929 8.8973 7.33929 7.4775C7.33929 6.05769 8.48844 4.90854 9.90825 4.90854C11.3281 4.90854 12.4772 6.05769 12.4772 7.4775C12.4772 8.8973 11.3281 10.0465 9.90825 10.0465Z"
      fill={color}
    />
  </svg>
);

export const IconConfigurações = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7359 13.4071L18.1915 12.0708C18.2646 11.6175 18.3023 11.1545 18.3023 10.6916C18.3023 10.2287 18.2646 9.76573 18.1915 9.31234L19.7359 7.97604C19.8524 7.87512 19.9358 7.7407 19.9749 7.59066C20.0141 7.44061 20.0072 7.28206 19.9552 7.13608L19.934 7.07404C19.5088 5.87143 18.8721 4.7566 18.0547 3.7834L18.0123 3.73329C17.9131 3.61529 17.7809 3.53047 17.6332 3.49C17.4854 3.44954 17.3291 3.45532 17.1846 3.50659L15.2676 4.19622C14.5602 3.6092 13.7703 3.14627 12.9168 2.82174L12.5466 0.793428C12.5186 0.640809 12.4455 0.500402 12.3368 0.390862C12.2282 0.281322 12.0891 0.207834 11.9382 0.180162L11.8746 0.168231C10.6461 -0.0560769 9.35393 -0.0560769 8.12544 0.168231L8.06178 0.180162C7.91086 0.207834 7.77184 0.281322 7.66318 0.390862C7.55452 0.500402 7.48136 0.640809 7.45343 0.793428L7.08088 2.83128C6.23412 3.15588 5.44557 3.61857 4.74653 4.20099L2.81538 3.50659C2.67099 3.45491 2.51448 3.44892 2.36665 3.48941C2.21882 3.5299 2.08666 3.61496 1.98774 3.73329L1.9453 3.7834C1.12886 4.75728 0.492285 5.87193 0.0660269 7.07404L0.0448055 7.13608C-0.0613015 7.43436 0.0259421 7.76843 0.264093 7.97604L1.8274 9.32666C1.75431 9.77527 1.71894 10.2334 1.71894 10.6892C1.71894 11.1474 1.75431 11.6055 1.8274 12.0518L0.264093 13.4024C0.147601 13.5033 0.0642265 13.6377 0.0250554 13.7878C-0.0141157 13.9378 -0.00722707 14.0963 0.0448055 14.2423L0.0660269 14.3044C0.492813 15.507 1.12474 16.6166 1.9453 17.595L1.98774 17.6451C2.0869 17.7631 2.21907 17.8479 2.36681 17.8884C2.51455 17.9289 2.67095 17.9231 2.81538 17.8718L4.74653 17.1774C5.44919 17.762 6.23438 18.225 7.08088 18.5471L7.45343 20.585C7.48136 20.7376 7.55452 20.878 7.66318 20.9875C7.77184 21.0971 7.91086 21.1706 8.06178 21.1982L8.12544 21.2102C9.36521 21.4357 10.6348 21.4357 11.8746 21.2102L11.9382 21.1982C12.0891 21.1706 12.2282 21.0971 12.3368 20.9875C12.4455 20.878 12.5186 20.7376 12.5466 20.585L12.9168 18.5567C13.77 18.233 14.5644 17.7685 15.2676 17.1822L17.1846 17.8718C17.329 17.9235 17.4855 17.9295 17.6334 17.889C17.7812 17.8485 17.9133 17.7634 18.0123 17.6451L18.0547 17.595C18.8753 16.6143 19.5072 15.507 19.934 14.3044L19.9552 14.2423C20.0613 13.9488 19.9741 13.6147 19.7359 13.4071V13.4071ZM16.5173 9.59392C16.5763 9.95424 16.6069 10.3241 16.6069 10.694C16.6069 11.0638 16.5763 11.4337 16.5173 11.794L16.3617 12.7509L18.1231 14.2757C17.8561 14.8983 17.519 15.4876 17.1186 16.032L14.9304 15.2469L14.19 15.8626C13.6265 16.3303 12.9993 16.6978 12.3202 16.9555L11.4218 17.2967L10.9998 19.6114C10.3338 19.6878 9.66147 19.6878 8.99552 19.6114L8.57345 17.292L7.68215 16.946C7.01014 16.6882 6.38529 16.3208 5.82646 15.8554L5.08607 15.2374L2.88376 16.0296C2.48291 15.4832 2.14808 14.8938 1.87928 14.2734L3.65952 12.7342L3.50625 11.7797C3.44966 11.4242 3.41901 11.0567 3.41901 10.694C3.41901 10.3289 3.4473 9.96378 3.50625 9.60823L3.65952 8.65373L1.87928 7.1146C2.14572 6.49179 2.48291 5.90477 2.88376 5.35832L5.08607 6.15056L5.82646 5.53252C6.38529 5.0672 7.01014 4.69972 7.68215 4.442L8.57581 4.10077L8.99788 1.78134C9.66046 1.70498 10.3372 1.70498 11.0021 1.78134L11.4242 4.096L12.3226 4.43723C12.9993 4.69495 13.6289 5.06243 14.1924 5.53013L14.9328 6.14579L17.121 5.36071C17.5218 5.90716 17.8566 6.49656 18.1254 7.11699L16.3641 8.6418L16.5173 9.59392ZM10.0024 6.25555C7.71045 6.25555 5.8524 8.13592 5.8524 10.4554C5.8524 12.7748 7.71045 14.6552 10.0024 14.6552C12.2943 14.6552 14.1523 12.7748 14.1523 10.4554C14.1523 8.13592 12.2943 6.25555 10.0024 6.25555ZM11.8698 12.3453C11.6249 12.5939 11.3338 12.791 11.0133 12.9253C10.6928 13.0596 10.3493 13.1285 10.0024 13.128C9.29734 13.128 8.63476 12.8488 8.13487 12.3453C7.88923 12.0974 7.69445 11.8028 7.56172 11.4785C7.42899 11.1541 7.36093 10.8064 7.36147 10.4554C7.36147 9.74186 7.63735 9.07133 8.13487 8.56544C8.63476 8.05956 9.29734 7.78275 10.0024 7.78275C10.7074 7.78275 11.37 8.05956 11.8698 8.56544C12.1155 8.81332 12.3103 9.10791 12.443 9.43225C12.5757 9.75659 12.6438 10.1043 12.6432 10.4554C12.6432 11.1688 12.3674 11.8394 11.8698 12.3453Z"
      fill={color}
    />
  </svg>
);

export const IconReportar = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2 5.0037H12.8V2.07407C12.8 1.61519 12.4425 1.24444 12 1.24444H1.8V0.207407C1.8 0.0933333 1.71 0 1.6 0H0.2C0.09 0 0 0.0933333 0 0.207407V20.5333C0 20.6474 0.09 20.7407 0.2 20.7407H1.6C1.71 20.7407 1.8 20.6474 1.8 20.5333V13.6889H8V16.6185C8 17.0774 8.3575 17.4481 8.8 17.4481H19.2C19.6425 17.4481 20 17.0774 20 16.6185V5.83333C20 5.37444 19.6425 5.0037 19.2 5.0037ZM1.8 11.8222V3.11111H11V11.8222H1.8ZM18.2 15.5815H9.8V13.6889H12.6C12.71 13.6889 12.8 13.5956 12.8 13.4815V6.87037H18.2V15.5815Z"
      fill={color}
    />
  </svg>
);

export const IconAjuda = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.47768 0 0 4.47768 0 10C0 15.5223 4.47768 20 10 20C15.5223 20 20 15.5223 20 10C20 4.47768 15.5223 0 10 0ZM10 18.3036C5.41518 18.3036 1.69643 14.5848 1.69643 10C1.69643 5.41518 5.41518 1.69643 10 1.69643C14.5848 1.69643 18.3036 5.41518 18.3036 10C18.3036 14.5848 14.5848 18.3036 10 18.3036Z"
      fill={size}
    />
    <path
      d="M10.4091 4.57143C11.4971 4.57143 12.3665 4.8701 13.0171 5.46743C13.6785 6.06476 14.0091 6.88076 14.0091 7.91543C14.0091 8.99276 13.6678 9.80343 12.9851 10.3474C12.3025 10.8914 11.3958 11.1634 10.2651 11.1634L10.2011 12.4274H8.61714L8.53714 9.91543H9.06514C10.0998 9.91543 10.8891 9.77676 11.4331 9.49943C11.9878 9.2221 12.2651 8.6941 12.2651 7.91543C12.2651 7.3501 12.0998 6.90743 11.7691 6.58743C11.4491 6.26743 11.0011 6.10743 10.4251 6.10743C9.84914 6.10743 9.39581 6.2621 9.06514 6.57143C8.73448 6.88076 8.56914 7.31276 8.56914 7.86743H6.85714C6.85714 7.22743 7.00114 6.65676 7.28914 6.15543C7.57714 5.6541 7.98781 5.26476 8.52114 4.98743C9.06514 4.7101 9.69448 4.57143 10.4091 4.57143ZM9.38514 15.9634C9.05448 15.9634 8.77714 15.8514 8.55314 15.6274C8.32914 15.4034 8.21714 15.1261 8.21714 14.7954C8.21714 14.4648 8.32914 14.1874 8.55314 13.9634C8.77714 13.7394 9.05448 13.6274 9.38514 13.6274C9.70514 13.6274 9.97714 13.7394 10.2011 13.9634C10.4251 14.1874 10.5371 14.4648 10.5371 14.7954C10.5371 15.1261 10.4251 15.4034 10.2011 15.6274C9.97714 15.8514 9.70514 15.9634 9.38514 15.9634Z"
      fill={color}
    />
  </svg>
);

export const IconCheck = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="1em"
    height="1em"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g fill="none" stroke={color} strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round" d="m8 12.5l3 3l5-6" />
      <circle cx="12" cy="12" r="10" />
    </g>
  </svg>
);

export const IconCheckbox = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z"
    />
  </svg>
);

export const IconMore = ({ color = '#069CD1', size = 20 }: any) => (
  <svg width="24" height="24">
    <circle
      cx="12"
      cy="12"
      r="11"
      fill="#2E294E"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M11.6651 8H12.3628C12.4248 8 12.4558 8.02963 12.4558 8.08889V15.9111C12.4558 15.9704 12.4248 16 12.3628 16H11.6651C11.6031 16 11.5721 15.9704 11.5721 15.9111V8.08889C11.5721 8.02963 11.6031 8 11.6651 8Z"
      fill="white"
    />
    <path
      d="M8.09302 11.5778H15.907C15.969 11.5778 16 11.6074 16 11.6667V12.3333C16 12.3926 15.969 12.4222 15.907 12.4222H8.09302C8.03101 12.4222 8 12.3926 8 12.3333V11.6667C8 11.6074 8.03101 11.5778 8.09302 11.5778Z"
      fill="white"
    />
  </svg>
);

export const IconLike = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3475 10.5279C19.7675 9.98909 20 9.32897 20 8.64217C20 7.55249 19.3725 6.52107 18.3625 5.94589C18.1025 5.79784 17.8064 5.71992 17.505 5.72019H11.51L11.66 2.73755C11.695 2.01676 11.4325 1.33238 10.9225 0.810598C10.6722 0.553417 10.3703 0.348793 10.0353 0.209374C9.70032 0.0699547 9.33946 -0.00129842 8.975 1.79108e-05C7.675 1.79108e-05 6.525 0.849429 6.18 2.0653L4.0325 9.61292H0.8C0.3575 9.61292 0 9.95997 0 10.3895V19.2234C0 19.653 0.3575 20 0.8 20H15.8325C16.0625 20 16.2875 19.9563 16.495 19.8689C17.685 19.3763 18.4525 18.2478 18.4525 16.9955C18.4525 16.6897 18.4075 16.3888 18.3175 16.0976C18.7375 15.5588 18.97 14.8987 18.97 14.2119C18.97 13.9061 18.925 13.6052 18.835 13.3139C19.255 12.7752 19.4875 12.115 19.4875 11.4282C19.4825 11.1224 19.4375 10.8191 19.3475 10.5279ZM1.8 18.2526V11.3603H3.825V18.2526H1.8ZM17.71 9.68573L17.1625 10.1468L17.51 10.7633C17.6245 10.9663 17.6838 11.1943 17.6825 11.4258C17.6825 11.8262 17.5025 12.2073 17.1925 12.4694L16.645 12.9305L16.9925 13.5469C17.107 13.75 17.1663 13.978 17.165 14.2094C17.165 14.6099 16.985 14.9909 16.675 15.253L16.1275 15.7141L16.475 16.3305C16.5895 16.5336 16.6488 16.7616 16.6475 16.9931C16.6475 17.5367 16.3175 18.0269 15.8075 18.2502H5.425V11.2826L7.9125 2.53369C7.97664 2.30945 8.11433 2.11161 8.30471 1.97016C8.49508 1.8287 8.72777 1.75135 8.9675 1.7498C9.1575 1.7498 9.345 1.8032 9.495 1.91241C9.7425 2.092 9.875 2.36381 9.86 2.65261L9.62 7.46755H17.48C17.925 7.73208 18.2 8.17863 18.2 8.64217C18.2 9.0426 18.02 9.4212 17.71 9.68573Z"
      fill={color}
    />
  </svg>
);

export const IconDeslike = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.652501 9.47214C0.232501 10.0109 8.15565e-07 10.671 7.55522e-07 11.3578C6.6026e-07 12.4475 0.627501 13.4789 1.6375 14.0541C1.89751 14.2022 2.19356 14.2801 2.495 14.2798L8.49 14.2798L8.34 17.2625C8.305 17.9832 8.5675 18.6676 9.0775 19.1894C9.32779 19.4466 9.62974 19.6512 9.96471 19.7906C10.2997 19.93 10.6605 20.0013 11.025 20C12.325 20 13.475 19.1506 13.82 17.9347L15.9675 10.3871L19.2 10.3871C19.6425 10.3871 20 10.04 20 9.61048L20 0.776604C20 0.347046 19.6425 -3.12536e-08 19.2 -6.99382e-08L4.1675 -1.38412e-06C3.9375 -1.40423e-06 3.7125 0.0436826 3.505 0.131051C2.315 0.623709 1.5475 1.75221 1.5475 3.00448C1.5475 3.31027 1.5925 3.61121 1.6825 3.90243C1.2625 4.4412 1.03 5.10132 1.03 5.78813C1.03 6.09391 1.075 6.39485 1.165 6.68607C0.745002 7.22484 0.512502 7.88496 0.512502 8.57177C0.517501 8.87755 0.562501 9.18091 0.652501 9.47214ZM18.2 1.74736L18.2 8.63972L16.175 8.63972L16.175 1.74736L18.2 1.74736ZM2.29 10.3143L2.8375 9.85316L2.49 9.23673C2.37552 9.03367 2.31615 8.80567 2.3175 8.57419C2.3175 8.17376 2.4975 7.79273 2.8075 7.53063L3.355 7.06952L3.0075 6.45309C2.89302 6.25004 2.83365 6.02203 2.835 5.79055C2.835 5.39012 3.015 5.00909 3.325 4.74699L3.8725 4.28588L3.525 3.66945C3.41052 3.46639 3.35115 3.23839 3.3525 3.00691C3.3525 2.46329 3.6825 1.97306 4.1925 1.74978L14.575 1.74979L14.575 8.71738L12.0875 17.4663C12.0234 17.6906 11.8857 17.8884 11.6953 18.0298C11.5049 18.1713 11.2722 18.2487 11.0325 18.2502C10.8425 18.2502 10.655 18.1968 10.505 18.0876C10.2575 17.908 10.125 17.6362 10.14 17.3474L10.38 12.5324L2.52 12.5324C2.075 12.2679 1.8 11.8214 1.8 11.3578C1.8 10.9574 1.98 10.5788 2.29 10.3143Z"
      fill={color}
    />
  </svg>
);

export const IconCompartilhar = ({ color = '#069CD1', size = 20 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.735 1.694L15.178 1l8.029 6.328v1.388l-8.029 6.072l-1.443-.694v-2.776h-.59c-4.06-.02-6.71.104-10.61 5.163l-1.534-.493a8.23 8.23 0 0 1 .271-2.255a11.026 11.026 0 0 1 3.92-6.793a11.339 11.339 0 0 1 7.502-2.547h1.04v-2.7zm1.804 7.917v2.776l5.676-4.281l-5.648-4.545v2.664h-2.86A9.299 9.299 0 0 0 5.77 8.848a10.444 10.444 0 0 0-2.401 4.122c3.351-3.213 6.19-3.359 9.798-3.359h2.373zm-7.647 5.896a4.31 4.31 0 1 1 4.788 7.166a4.31 4.31 0 0 1-4.788-7.166zm.955 5.728a2.588 2.588 0 1 0 2.878-4.302a2.588 2.588 0 0 0-2.878 4.302z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconFavoritar = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0273 3.53906C16.7655 2.93288 16.3881 2.38357 15.916 1.92187C15.4436 1.4588 14.8866 1.0908 14.2754 0.837889C13.6416 0.574594 12.9617 0.439825 12.2754 0.441405C11.3125 0.441405 10.373 0.705077 9.55664 1.20312C9.36133 1.32226 9.17578 1.45312 9 1.5957C8.82422 1.45312 8.63867 1.32226 8.44336 1.20312C7.62695 0.705077 6.6875 0.441405 5.72461 0.441405C5.03125 0.441405 4.35938 0.574217 3.72461 0.837889C3.11133 1.0918 2.55859 1.45703 2.08398 1.92187C1.61132 2.38305 1.23375 2.93249 0.972656 3.53906C0.701172 4.16992 0.5625 4.83984 0.5625 5.5293C0.5625 6.17969 0.695313 6.85742 0.958984 7.54687C1.17969 8.12304 1.49609 8.7207 1.90039 9.32422C2.54102 10.2793 3.42188 11.2754 4.51562 12.2852C6.32812 13.959 8.12305 15.1152 8.19922 15.1621L8.66211 15.459C8.86719 15.5898 9.13086 15.5898 9.33594 15.459L9.79883 15.1621C9.875 15.1133 11.668 13.959 13.4824 12.2852C14.5762 11.2754 15.457 10.2793 16.0977 9.32422C16.502 8.7207 16.8203 8.12304 17.0391 7.54687C17.3027 6.85742 17.4355 6.17969 17.4355 5.5293C17.4375 4.83984 17.2988 4.16992 17.0273 3.53906ZM9 13.9141C9 13.9141 2.04688 9.45898 2.04688 5.5293C2.04688 3.53906 3.69336 1.92578 5.72461 1.92578C7.15234 1.92578 8.39062 2.72265 9 3.88672C9.60938 2.72265 10.8477 1.92578 12.2754 1.92578C14.3066 1.92578 15.9531 3.53906 15.9531 5.5293C15.9531 9.45898 9 13.9141 9 13.9141Z"
      fill={color}
    />
  </svg>
);

export const IconUser = ({ color = '#069CD1', size = 13 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 10C11.5117 10 13.75 7.76172 13.75 5C13.75 2.23828 11.5117 0 8.75 0C5.98828 0 3.75 2.23828 3.75 5C3.75 7.76172 5.98828 10 8.75 10ZM12.25 11.25H11.5977C10.7305 11.6484 9.76562 11.875 8.75 11.875C7.73438 11.875 6.77344 11.6484 5.90234 11.25H5.25C2.35156 11.25 0 13.6016 0 16.5V18.125C0 19.1602 0.839844 20 1.875 20H15.625C16.6602 20 17.5 19.1602 17.5 18.125V16.5C17.5 13.6016 15.1484 11.25 12.25 11.25Z"
      fill={color}
    />
  </svg>
);

export const IconLoading = ({ color = '#069CD1', size = 40 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="2" r="0" fill={color}>
      <animate
        attributeName="r"
        begin="0"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(45 12 12)">
      <animate
        attributeName="r"
        begin="0.125s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(90 12 12)">
      <animate
        attributeName="r"
        begin="0.25s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(135 12 12)">
      <animate
        attributeName="r"
        begin="0.375s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(180 12 12)">
      <animate
        attributeName="r"
        begin="0.5s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(225 12 12)">
      <animate
        attributeName="r"
        begin="0.625s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(270 12 12)">
      <animate
        attributeName="r"
        begin="0.75s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
    <circle cx="12" cy="2" r="0" fill={color} transform="rotate(315 12 12)">
      <animate
        attributeName="r"
        begin="0.875s"
        calcMode="spline"
        dur="1s"
        keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
        repeatCount="indefinite"
        values="0;2;0;0"
      />
    </circle>
  </svg>
);

export const IconVideo = ({ color = '#fff', size = 20 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 0H2.16667C1.2475 0 0.5 0.7475 0.5 1.66667V13.3333C0.5 14.2525 1.2475 15 2.16667 15H15.5C16.4192 15 17.1667 14.2525 17.1667 13.3333V1.66667C17.1667 0.7475 16.4192 0 15.5 0ZM15.5008 5V5H15.1133L12.8908 1.66667H15.5L15.5008 5ZM6.78 5L4.5575 1.66667H6.72083L8.94333 5H6.78ZM10.9467 5L8.72417 1.66667H10.8875L13.11 5H10.9467ZM2.16667 1.66667H2.55417L4.77667 5H2.16667V1.66667ZM2.16667 13.3333V6.66667H15.5L15.5017 13.3333H2.16667Z"
      fill={color}
    />
    <path d="M7.16663 12.5L11.75 10L7.16663 7.5V12.5Z" fill={color} />
  </svg>
);

export const IconPlay = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.93831 0.560977C1.60621 -0.146702 0 0.818797 0 2.32721V12.6728C0 14.1812 1.60621 15.1467 2.93831 14.439L12.6753 9.26623C14.0909 8.5142 14.0909 6.4858 12.6753 5.73377L2.93831 0.560977Z"
      fill="white"
    />
  </svg>
);

export const IconTransmissao = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.56058 0.298612C4.65819 0.393172 4.73561 0.505462 4.78844 0.629065C4.84127 0.752667 4.86846 0.885157 4.86846 1.01896C4.86846 1.15276 4.84127 1.28525 4.78844 1.40885C4.73561 1.53245 4.65819 1.64475 4.56058 1.73931C2.98539 3.26737 2.10047 5.33972 2.10047 7.50055C2.10047 9.66138 2.98539 11.7337 4.56058 13.2618C4.65805 13.3564 4.73535 13.4687 4.78807 13.5923C4.84079 13.7158 4.86789 13.8483 4.86785 13.982C4.8678 14.1157 4.84059 14.2481 4.78778 14.3717C4.73497 14.4952 4.65759 14.6075 4.56006 14.702C4.46253 14.7965 4.34676 14.8715 4.21935 14.9226C4.09195 14.9738 3.95541 15 3.81752 15C3.67964 15 3.54312 14.9736 3.41575 14.9223C3.28839 14.8711 3.17267 14.7961 3.07521 14.7015C-1.02507 10.7245 -1.02507 4.27554 3.07521 0.298612C3.1727 0.203948 3.28847 0.128849 3.41591 0.0776108C3.54334 0.0263728 3.67994 0 3.8179 0C3.95585 0 4.09245 0.0263728 4.21988 0.0776108C4.34732 0.128849 4.46309 0.203948 4.56058 0.298612V0.298612ZM17.9248 0.298612C22.0251 4.27656 22.0251 10.7245 17.9248 14.7015C17.7268 14.8869 17.4616 14.9896 17.1864 14.9872C16.9112 14.9849 16.6479 14.8778 16.4533 14.6891C16.2586 14.5003 16.1482 14.2449 16.1458 13.978C16.1434 13.711 16.2492 13.4538 16.4405 13.2618C18.0157 11.7337 18.9006 9.66138 18.9006 7.50055C18.9006 5.33972 18.0157 3.26737 16.4405 1.73931C16.2435 1.54839 16.1328 1.28941 16.1327 1.01932C16.1326 0.749232 16.2431 0.490169 16.4399 0.299121C16.6368 0.108073 16.9038 0.000690203 17.1823 0.000594732C17.4607 0.000499261 17.7278 0.107699 17.9248 0.298612V0.298612ZM7.67516 3.2248C7.87195 3.41573 7.9825 3.67466 7.9825 3.94464C7.9825 4.21461 7.87195 4.47354 7.67516 4.66447C7.293 5.03509 6.98986 5.4751 6.78303 5.95935C6.57621 6.44361 6.46976 6.96264 6.46976 7.48681C6.46976 8.01097 6.57621 8.53 6.78303 9.01426C6.98986 9.49852 7.293 9.93852 7.67516 10.3091C7.77542 10.4031 7.85539 10.5154 7.9104 10.6396C7.96542 10.7638 7.99438 10.8975 7.99559 11.0326C7.9968 11.1678 7.97024 11.3019 7.91746 11.427C7.86468 11.5522 7.78673 11.6658 7.68817 11.7614C7.58961 11.857 7.4724 11.9326 7.34339 11.9838C7.21438 12.035 7.07615 12.0608 6.93677 12.0596C6.79739 12.0584 6.65964 12.0303 6.53157 11.977C6.4035 11.9236 6.28766 11.8461 6.19083 11.7488C5.02544 10.6184 4.37073 9.08536 4.37073 7.48681C4.37073 5.88825 5.02544 4.35517 6.19083 3.2248C6.38768 3.03392 6.65464 2.92669 6.93299 2.92669C7.21134 2.92669 7.4783 3.03392 7.67516 3.2248V3.2248ZM14.9803 3.2248C16.1457 4.35517 16.8004 5.88825 16.8004 7.48681C16.8004 9.08536 16.1457 10.6184 14.9803 11.7488C14.8828 11.8434 14.7671 11.9185 14.6397 11.9697C14.5124 12.0209 14.3758 12.0473 14.238 12.0473C14.1001 12.0474 13.9635 12.0211 13.8361 11.97C13.7087 11.9188 13.593 11.8439 13.4954 11.7493C13.3979 11.6548 13.3205 11.5426 13.2677 11.419C13.2149 11.2955 13.1877 11.1631 13.1876 11.0293C13.1876 10.8956 13.2147 10.7632 13.2674 10.6396C13.3201 10.516 13.3974 10.4037 13.4949 10.3091C13.8771 9.93852 14.1802 9.49852 14.387 9.01426C14.5938 8.53 14.7003 8.01097 14.7003 7.48681C14.7003 6.96264 14.5938 6.44361 14.387 5.95935C14.1802 5.4751 13.8771 5.03509 13.4949 4.66447C13.2981 4.47342 13.1875 4.21436 13.1876 3.94428C13.1877 3.67419 13.2985 3.4152 13.4954 3.22429C13.6924 3.03338 13.9595 2.92618 14.238 2.92627C14.5164 2.92637 14.7834 3.03375 14.9803 3.2248V3.2248ZM10.585 6.04509C10.7918 6.04509 10.9966 6.0846 11.1876 6.16135C11.3786 6.2381 11.5522 6.35059 11.6984 6.49241C11.8447 6.63423 11.9606 6.80259 12.0398 6.98788C12.1189 7.17318 12.1596 7.37177 12.1596 7.57233C12.1596 7.77289 12.1189 7.97149 12.0398 8.15678C11.9606 8.34207 11.8447 8.51043 11.6984 8.65225C11.5522 8.79407 11.3786 8.90656 11.1876 8.98331C10.9966 9.06007 10.7918 9.09957 10.585 9.09957C10.1674 9.09957 9.76691 8.93866 9.47161 8.65225C9.17632 8.36584 9.01042 7.97738 9.01042 7.57233C9.01042 7.16728 9.17632 6.77882 9.47161 6.49241C9.76691 6.206 10.1674 6.04509 10.585 6.04509V6.04509Z"
      fill="#069CD1"
    />
  </svg>
);

export const IconFile = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width={0.76 * size}
    height={size}
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7864 5.26406L10.8955 0.220313C10.7591 0.0796876 10.575 0 10.3818 0H0.727273C0.325 0 0 0.335156 0 0.75V20.25C0 20.6648 0.325 21 0.727273 21H15.2727C15.675 21 16 20.6648 16 20.25V5.79609C16 5.59688 15.9227 5.40469 15.7864 5.26406ZM14.3227 6.14063H10.0455V1.72969L14.3227 6.14063ZM14.3636 19.3125H1.63636V1.6875H8.5V6.75C8.5 7.01107 8.60057 7.26145 8.77958 7.44606C8.95859 7.63066 9.20138 7.73438 9.45455 7.73438H14.3636V19.3125Z"
      fill="#AAAAAA"
    />
  </svg>
);

export const IconCarregaVideo = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width="124"
    height="126"
    viewBox="0 0 124 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M65.587 27.9837H58.4354C57.7812 27.9837 57.246 28.5112 57.246 29.1558V69.4905C57.246 69.8714 57.4244 70.223 57.7366 70.4428L82.3138 88.1267C82.849 88.5077 83.5924 88.4051 83.979 87.8777L88.2313 82.1637C88.6328 81.6216 88.5138 80.8891 87.9786 80.5228L66.7765 65.4174V29.1558C66.7765 28.5112 66.2412 27.9837 65.587 27.9837ZM98.2674 39.0014L121.581 44.6128C122.324 44.7886 123.053 44.2319 123.053 43.4847L123.172 19.823C123.172 18.8414 122.027 18.2847 121.254 18.9L97.8213 36.9356C97.6442 37.0706 97.5094 37.2521 97.4323 37.4593C97.3553 37.6664 97.3391 37.8908 97.3857 38.1066C97.4323 38.3224 97.5398 38.5209 97.6957 38.6791C97.8517 38.8374 98.0498 38.9491 98.2674 39.0014ZM123.201 83.1161L114.771 80.2591C114.477 80.1598 114.155 80.1778 113.875 80.3092C113.594 80.4406 113.377 80.6751 113.269 80.9623C112.987 81.7095 112.69 82.4421 112.377 83.1747C109.731 89.3428 105.939 94.8956 101.092 99.6572C96.2991 104.395 90.6186 108.172 84.3656 110.777C77.8879 113.476 70.9249 114.861 63.892 114.85C56.785 114.85 49.9011 113.488 43.4185 110.777C37.1655 108.172 31.485 104.395 26.6918 99.6572C21.8596 94.8956 18.0682 89.3428 15.4068 83.1747C12.6832 76.788 11.2878 69.9277 11.3032 63C11.3032 55.9967 12.6859 49.1986 15.4365 42.8107C18.0831 36.6426 21.8745 31.0898 26.7215 26.3282C31.5147 21.5903 37.1953 17.8137 43.4482 15.2079C49.9011 12.4975 56.7999 11.1349 63.9069 11.1349C71.0139 11.1349 77.8979 12.4975 84.3805 15.2079C90.6334 17.8137 96.314 21.5903 101.107 26.3282C102.624 27.8372 104.051 29.4049 105.36 31.0605L114.251 24.2037C102.549 9.46467 84.3358 -0.0146342 63.8772 1.69593e-05C28.2529 0.0146681 -0.353535 28.5258 0.00330241 63.6447C0.36014 98.1481 28.8328 126 63.9069 126C91.4875 126 114.979 108.77 123.93 84.6398C124.153 84.0244 123.826 83.3358 123.201 83.1161Z"
      fill="white"
    />
  </svg>
);

export const IconCalendar = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 1.40625H11.7188V0.15625C11.7188 0.0703125 11.6484 0 11.5625 0H10.4688C10.3828 0 10.3125 0.0703125 10.3125 0.15625V1.40625H5.3125V0.15625C5.3125 0.0703125 5.24219 0 5.15625 0H4.0625C3.97656 0 3.90625 0.0703125 3.90625 0.15625V1.40625H0.625C0.279297 1.40625 0 1.68555 0 2.03125V15C0 15.3457 0.279297 15.625 0.625 15.625H15C15.3457 15.625 15.625 15.3457 15.625 15V2.03125C15.625 1.68555 15.3457 1.40625 15 1.40625ZM14.2188 14.2188H1.40625V6.79688H14.2188V14.2188ZM1.40625 5.46875V2.8125H3.90625V3.75C3.90625 3.83594 3.97656 3.90625 4.0625 3.90625H5.15625C5.24219 3.90625 5.3125 3.83594 5.3125 3.75V2.8125H10.3125V3.75C10.3125 3.83594 10.3828 3.90625 10.4688 3.90625H11.5625C11.6484 3.90625 11.7188 3.83594 11.7188 3.75V2.8125H14.2188V5.46875H1.40625Z"
      fill={color}
    />
  </svg>
);

export const IconRelogio = ({ color = 'white', size = 18 }: any) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66663 16.3333C12.9008 16.3333 16.3333 12.9008 16.3333 8.66663C16.3333 4.43247 12.9008 1 8.66663 1C4.43247 1 1 4.43247 1 8.66663C1 12.9008 4.43247 16.3333 8.66663 16.3333Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9665 11.7333L9.11577 9.88255C8.82819 9.59507 8.66659 9.20512 8.6665 8.79849V4.06665"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconInfo = ({ color = '#069CD1', size = 16 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66509 14.0526C11.1928 14.0526 14.0526 11.1928 14.0526 7.66509C14.0526 4.13737 11.1928 1.27759 7.66509 1.27759C4.13737 1.27759 1.27759 4.13737 1.27759 7.66509C1.27759 11.1928 4.13737 14.0526 7.66509 14.0526Z"
      stroke={color}
      strokeWidth="1.66667"
    />
    <path
      d="M7.66504 4.47144H7.67143"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
    <path
      d="M6.3877 7.02637H7.6652V10.2201M6.3877 10.2201H8.9427"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowUp = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.92107 0.340493L0.341094 6.92047C-0.113699 7.37527 -0.113699 8.11068 0.341094 8.56063L1.43453 9.65407C1.88932 10.1089 2.62473 10.1089 3.07469 9.65407L7.74357 4.99486L12.4076 9.65891C12.8624 10.1137 13.5978 10.1137 14.0478 9.65891L15.146 8.56547C15.6008 8.11068 15.6008 7.37527 15.146 6.92531L8.56607 0.345331C8.11128 -0.1143 7.37587 -0.1143 6.92107 0.340493V0.340493Z"
      fill={color}
    />
  </svg>
);

export const IconArrowDown = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.56599 9.65951L15.146 3.07953C15.6008 2.62473 15.6008 1.88933 15.146 1.43937L14.0525 0.345933C13.5977 -0.10886 12.8623 -0.10886 12.4124 0.345933L7.74349 5.00514L3.07944 0.341094C2.62465 -0.113699 1.88924 -0.113699 1.43929 0.341094L0.341011 1.43453C-0.113782 1.88932 -0.113782 2.62473 0.341011 3.07469L6.92099 9.65467C7.37578 10.1143 8.11119 10.1143 8.56599 9.65951Z"
      fill={color}
    />
  </svg>
);

export const IconAgenda = ({ color = '#8A7BE8', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M12 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm-5 4a1 1 0 1 0-1-1a1 1 0 0 0 1 1Zm5 0a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM7 14a1 1 0 1 0-1-1a1 1 0 0 0 1 1ZM19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM7 18a1 1 0 1 0-1-1a1 1 0 0 0 1 1Z"
    />
  </svg>
);

export const IconClose = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 1024 1024"
  >
    <path
      fill={color}
      d="m563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8L295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512L196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1l216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
    />
  </svg>
);

export const IconPesquisar = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392l.604.646l2.121-2.121l-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5s5 2.243 5 5s-2.243 5-5 5z"
    />
  </svg>
);

export const IconChevronLeft = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
    />
  </svg>
);

export const IconCloseSquare = ({ color = '#000', size = 22 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25977 17.27H9.02677C9.16777 17.27 9.30277 17.207 9.39577 17.099L11.9998 13.994L14.6038 17.099C14.6938 17.207 14.8288 17.27 14.9728 17.27H16.7398C16.9438 17.27 17.0548 17.033 16.9228 16.877L13.2538 12.5L16.9258 8.12298C17.0578 7.96698 16.9468 7.72998 16.7428 7.72998H14.9758C14.8348 7.72998 14.6998 7.79298 14.6068 7.90098L11.9998 11.006L9.39577 7.90098C9.30577 7.79298 9.17077 7.72998 9.02677 7.72998H7.25977C7.05577 7.72998 6.94477 7.96698 7.07677 8.12298L10.7458 12.5L7.07677 16.877C7.0472 16.9118 7.02823 16.9543 7.02211 16.9995C7.01599 17.0447 7.02298 17.0908 7.04225 17.1322C7.06152 17.1735 7.09226 17.2085 7.13081 17.2329C7.16937 17.2574 7.21413 17.2702 7.25977 17.27V17.27Z"
      fill={color}
    />
    <path
      d="M23.04 0.5H0.96C0.429 0.5 0 0.929 0 1.46V23.54C0 24.071 0.429 24.5 0.96 24.5H23.04C23.571 24.5 24 24.071 24 23.54V1.46C24 0.929 23.571 0.5 23.04 0.5ZM21.84 22.34H2.16V2.66H21.84V22.34Z"
      fill={color}
    />
  </svg>
);

export const IconPlaylist = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="M5 10h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0-4h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 8h6c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm9 .88v4.23c0 .39.42.63.76.43l3.53-2.12c.32-.19.32-.66 0-.86l-3.53-2.12a.508.508 0 0 0-.76.44z"
    />
  </svg>
);

export const IconCLoseCircle = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 1024 1024"
  >
    <path
      fill={color}
      d="M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4l-66.1-.3c-4.4 0-8 3.5-8 8c0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4l66 .3c4.4 0 8-3.5 8-8c0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"
    />
    <path
      fill={color}
      d="M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448s448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372z"
    />
  </svg>
);

export const IconDots = ({ color = '#000', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2z"
    />
  </svg>
);

export const IconTrash = ({ color = '#000', size = '1em' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6h16l-1.58 14.22A2 2 0 0 1 16.432 22H7.568a2 2 0 0 1-1.988-1.78L4 6Zm3.345-2.853A2 2 0 0 1 9.154 2h5.692a2 2 0 0 1 1.81 1.147L18 6H6l1.345-2.853ZM2 6h20m-12 5v5m4-5v5"
    />
  </svg>
);

export const IconDestaque = ({ color = '#000', size = 22 }: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 6.96533C7.5 6.48805 7.5 6.24941 7.59974 6.11618C7.68666 6.00007 7.81971 5.92744 7.96438 5.9171C8.13038 5.90525 8.33112 6.03429 8.73261 6.29239L13.4532 9.32706C13.8016 9.55102 13.9758 9.663 14.0359 9.80539C14.0885 9.9298 14.0885 10.0702 14.0359 10.1946C13.9758 10.337 13.8016 10.449 13.4532 10.6729L8.73261 13.7076C8.33112 13.9657 8.13038 14.0948 7.96438 14.0829C7.81971 14.0726 7.68666 13.9999 7.59974 13.8838C7.5 13.7506 7.5 13.512 7.5 13.0347V6.96533Z"
      stroke="#069CD1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8Z"
      stroke="#069CD1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconMarca = ({ color = '#000', size = 22 }: any) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 3L16 5L20 1M10.5 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H15C15.93 19 16.395 19 16.7765 18.8978C17.8117 18.6204 18.6204 17.8117 18.8978 16.7765C19 16.395 19 15.93 19 15M8.5 6.5C8.5 7.60457 7.60457 8.5 6.5 8.5C5.39543 8.5 4.5 7.60457 4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5C7.60457 4.5 8.5 5.39543 8.5 6.5ZM12.99 9.91815L4.53115 17.608C4.05536 18.0406 3.81747 18.2568 3.79643 18.4442C3.77819 18.6066 3.84045 18.7676 3.96319 18.8755C4.10478 19 4.42628 19 5.06929 19H14.456C15.8951 19 16.6147 19 17.1799 18.7582C17.8894 18.4547 18.4547 17.8894 18.7582 17.1799C19 16.6147 19 15.8951 19 14.456C19 13.9717 19 13.7296 18.9471 13.5042C18.8805 13.2208 18.753 12.9554 18.5733 12.7264C18.4303 12.5442 18.2412 12.3929 17.8631 12.0905L15.0658 9.85266C14.6874 9.54991 14.4982 9.39853 14.2898 9.34511C14.1061 9.29802 13.9129 9.30412 13.7325 9.36269C13.5279 9.42914 13.3486 9.59215 12.99 9.91815Z"
      stroke="#069CD1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconInformacoes = ({ color = '#000', size = 22 }: any) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7V11M11 15H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconWWW = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M3.338 17A9.996 9.996 0 0 0 12 22a9.996 9.996 0 0 0 8.662-5M3.338 7A9.996 9.996 0 0 1 12 2a9.996 9.996 0 0 1 8.662 5" />
      <path d="M13 21.95s1.408-1.853 2.295-4.95M13 2.05S14.408 3.902 15.295 7M11 21.95S9.592 20.098 8.705 17M11 2.05S9.592 3.902 8.705 7M9 10l1.5 5l1.5-5l1.5 5l1.5-5M1 10l1.5 5L4 10l1.5 5L7 10m10 0l1.5 5l1.5-5l1.5 5l1.5-5" />
    </g>
  </svg>
);

export const IconTwitter = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9217 1.8246C18.2258 2.13293 17.4783 2.34127 16.6925 2.43543C17.5033 1.95026 18.11 1.18665 18.3992 0.287099C17.6374 0.73959 16.8036 1.05809 15.9342 1.22877C15.3495 0.604486 14.5751 0.190704 13.7311 0.0516603C12.8872 -0.0873831 12.0209 0.0560916 11.2669 0.459809C10.5128 0.863527 9.91315 1.5049 9.56096 2.28435C9.20878 3.0638 9.12378 3.93772 9.31917 4.77043C7.77557 4.69293 6.26552 4.29172 4.88702 3.59285C3.50852 2.89398 2.29237 1.91307 1.3175 0.713765C0.984167 1.28877 0.7925 1.95543 0.7925 2.66543C0.792128 3.30459 0.949527 3.93397 1.25073 4.49771C1.55194 5.06145 1.98763 5.54213 2.51917 5.8971C1.90273 5.87748 1.29989 5.71092 0.760833 5.41127V5.46126C0.760771 6.35772 1.07086 7.22658 1.63849 7.92043C2.20611 8.61428 2.99631 9.09037 3.875 9.26793C3.30315 9.4227 2.70361 9.44549 2.12167 9.3346C2.36958 10.1059 2.8525 10.7805 3.50281 11.2637C4.15312 11.747 4.93826 12.0147 5.74833 12.0296C4.37319 13.1091 2.67491 13.6947 0.926667 13.6921C0.616984 13.6922 0.307564 13.6741 0 13.6379C1.77456 14.7789 3.84028 15.3844 5.95 15.3821C13.0917 15.3821 16.9958 9.4671 16.9958 4.3371C16.9958 4.17043 16.9917 4.0021 16.9842 3.83543C17.7436 3.28624 18.3991 2.60618 18.92 1.8271L18.9217 1.8246Z"
      fill="#069CD1"
    />
  </svg>
);

export const IconFacebook = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 11 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0094 11.2494L10.565 7.63H7.09188V5.28125C7.09188 4.29125 7.57687 3.32562 9.1325 3.32562H10.7113V0.244375C10.7113 0.244375 9.27875 0 7.90875 0C5.04875 0 3.17937 1.73375 3.17937 4.87187V7.63062H0V11.25H3.17937V20H7.09188V11.25L10.0094 11.2494Z"
      fill="#069CD1"
    />
  </svg>
);

export const IconInstagram = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3875 0.055C6.365 0.00999998 6.67667 0 9.16667 0C11.6567 0 11.9683 0.0108333 12.945 0.055C13.9217 0.0991666 14.5883 0.255 15.1717 0.480833C15.7825 0.711667 16.3367 1.0725 16.795 1.53917C17.2617 1.99667 17.6217 2.55 17.8517 3.16167C18.0783 3.745 18.2333 4.41167 18.2783 5.38667C18.3233 6.36583 18.3333 6.6775 18.3333 9.16667C18.3333 11.6567 18.3225 11.9683 18.2783 12.9458C18.2342 13.9208 18.0783 14.5875 17.8517 15.1708C17.6217 15.7826 17.2611 16.3368 16.795 16.795C16.3367 17.2617 15.7825 17.6217 15.1717 17.8517C14.5883 18.0783 13.9217 18.2333 12.9467 18.2783C11.9683 18.3233 11.6567 18.3333 9.16667 18.3333C6.67667 18.3333 6.365 18.3225 5.3875 18.2783C4.4125 18.2342 3.74583 18.0783 3.1625 17.8517C2.55077 17.6216 1.99652 17.261 1.53833 16.795C1.07198 16.3372 0.711096 15.7832 0.480833 15.1717C0.255 14.5883 0.1 13.9217 0.055 12.9467C0.00999998 11.9675 0 11.6558 0 9.16667C0 6.67667 0.0108333 6.365 0.055 5.38833C0.0991666 4.41167 0.255 3.745 0.480833 3.16167C0.711436 2.55007 1.0726 1.99609 1.53917 1.53833C1.9967 1.07208 2.55039 0.711203 3.16167 0.480833C3.745 0.255 4.41167 0.1 5.38667 0.055H5.3875ZM12.8708 1.705C11.9042 1.66083 11.6142 1.65167 9.16667 1.65167C6.71917 1.65167 6.42917 1.66083 5.4625 1.705C4.56833 1.74583 4.08333 1.895 3.76 2.02083C3.3325 2.1875 3.02667 2.385 2.70583 2.70583C2.4017 3.00171 2.16765 3.3619 2.02083 3.76C1.895 4.08333 1.74583 4.56833 1.705 5.4625C1.66083 6.42917 1.65167 6.71917 1.65167 9.16667C1.65167 11.6142 1.66083 11.9042 1.705 12.8708C1.74583 13.765 1.895 14.25 2.02083 14.5733C2.1675 14.9708 2.40167 15.3317 2.70583 15.6275C3.00167 15.9317 3.3625 16.1658 3.76 16.3125C4.08333 16.4383 4.56833 16.5875 5.4625 16.6283C6.42917 16.6725 6.71833 16.6817 9.16667 16.6817C11.615 16.6817 11.9042 16.6725 12.8708 16.6283C13.765 16.5875 14.25 16.4383 14.5733 16.3125C15.0008 16.1458 15.3067 15.9483 15.6275 15.6275C15.9317 15.3317 16.1658 14.9708 16.3125 14.5733C16.4383 14.25 16.5875 13.765 16.6283 12.8708C16.6725 11.9042 16.6817 11.6142 16.6817 9.16667C16.6817 6.71917 16.6725 6.42917 16.6283 5.4625C16.5875 4.56833 16.4383 4.08333 16.3125 3.76C16.1458 3.3325 15.9483 3.02667 15.6275 2.70583C15.3316 2.40173 14.9714 2.16768 14.5733 2.02083C14.25 1.895 13.765 1.74583 12.8708 1.705ZM7.99583 11.9925C8.64972 12.2647 9.37781 12.3014 10.0558 12.0964C10.7337 11.8914 11.3195 11.4574 11.713 10.8685C12.1065 10.2796 12.2834 9.57239 12.2134 8.86759C12.1434 8.16278 11.8308 7.50414 11.3292 7.00417C11.0094 6.68456 10.6227 6.43984 10.1969 6.28762C9.77121 6.1354 9.31702 6.07947 8.86708 6.12385C8.41713 6.16823 7.98263 6.31181 7.59484 6.54427C7.20705 6.77674 6.87562 7.09229 6.62442 7.46821C6.37322 7.84413 6.20849 8.27107 6.1421 8.7183C6.0757 9.16553 6.10929 9.62191 6.24045 10.0546C6.37161 10.4873 6.59707 10.8855 6.9006 11.2206C7.20413 11.5557 7.57819 11.8193 7.99583 11.9925ZM5.835 5.835C6.27252 5.39748 6.79193 5.05042 7.36358 4.81363C7.93523 4.57685 8.54792 4.45498 9.16667 4.45498C9.78541 4.45498 10.3981 4.57685 10.9698 4.81363C11.5414 5.05042 12.0608 5.39748 12.4983 5.835C12.9359 6.27252 13.2829 6.79193 13.5197 7.36358C13.7565 7.93523 13.8784 8.54792 13.8784 9.16667C13.8784 9.78541 13.7565 10.3981 13.5197 10.9698C13.2829 11.5414 12.9359 12.0608 12.4983 12.4983C11.6147 13.3819 10.4163 13.8784 9.16667 13.8784C7.91705 13.8784 6.71861 13.3819 5.835 12.4983C4.95139 11.6147 4.45498 10.4163 4.45498 9.16667C4.45498 7.91705 4.95139 6.71861 5.835 5.835ZM14.9233 5.15667C15.0318 5.05439 15.1185 4.9314 15.1786 4.79498C15.2386 4.65856 15.2707 4.51147 15.2728 4.36244C15.275 4.21341 15.2473 4.06546 15.1912 3.92734C15.1352 3.78923 15.052 3.66376 14.9466 3.55837C14.8412 3.45297 14.7158 3.3698 14.5777 3.31376C14.4395 3.25773 14.2916 3.22998 14.1426 3.23215C13.9935 3.23432 13.8464 3.26638 13.71 3.32641C13.5736 3.38645 13.4506 3.47325 13.3483 3.58167C13.1494 3.79252 13.0405 4.0726 13.0448 4.36244C13.049 4.65228 13.166 4.92907 13.371 5.13404C13.5759 5.339 13.8527 5.45602 14.1426 5.46025C14.4324 5.46447 14.7125 5.35557 14.9233 5.15667Z"
      fill="#069CD1"
    />
  </svg>
);

export const IconTikTok = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1022 4.63402C14.9756 4.56856 14.8524 4.4968 14.733 4.41902C14.386 4.18963 14.0679 3.91935 13.7855 3.61402C13.078 2.80486 12.8138 1.98402 12.7172 1.40986H12.7205C12.6397 0.932357 12.673 0.624023 12.6788 0.624023H9.45799V13.0765C9.45799 13.2432 9.45799 13.409 9.45132 13.5724C9.45132 13.5924 9.44882 13.6107 9.44799 13.6332C9.44799 13.6415 9.44799 13.6515 9.44549 13.6607V13.6682C9.41167 14.1149 9.26858 14.5464 9.02881 14.9248C8.78904 15.3032 8.45995 15.6169 8.07049 15.8382C7.66418 16.0693 7.20462 16.1906 6.73716 16.1899C5.23716 16.1899 4.02049 14.9665 4.02049 13.4557C4.02049 11.944 5.23716 10.7207 6.73716 10.7207C7.02132 10.7207 7.30382 10.7657 7.57382 10.854L7.57799 7.57402C6.758 7.46823 5.92498 7.53358 5.13152 7.76594C4.33806 7.9983 3.60138 8.39262 2.96799 8.92402C2.41287 9.40614 1.94614 9.98144 1.58882 10.624C1.45299 10.8582 0.939656 11.8007 0.87799 13.329C0.838823 14.1957 1.09966 15.0957 1.22382 15.4665V15.4749C1.30132 15.6932 1.60466 16.4399 2.09799 17.069C2.49582 17.574 2.96586 18.0177 3.49299 18.3857V18.3774L3.50049 18.3857C5.05882 19.444 6.78799 19.3749 6.78799 19.3749C7.08716 19.3624 8.08966 19.3749 9.22799 18.8357C10.4905 18.2374 11.2088 17.3465 11.2088 17.3465C11.6681 16.8141 12.0333 16.2074 12.2888 15.5524C12.5805 14.7857 12.6772 13.8674 12.6772 13.5007V6.89319C12.7163 6.91652 13.2372 7.26069 13.2372 7.26069C13.2372 7.26069 13.9872 7.74152 15.1563 8.05402C15.9947 8.27652 17.1255 8.32402 17.1255 8.32402V5.12652C16.7297 5.16986 15.9255 5.04486 15.1013 4.63486L15.1022 4.63402Z"
      fill="#069CD1"
    />
  </svg>
);

export const IconPause = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth="2"
      d="M7 5v14M17 5v14"
    />
  </svg>
);

export const IconPlayPlayerVideo = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
  >
    <path
      fill={color}
      d="m11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
    />
  </svg>
);

export const IconReload = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 1024 1024"
  >
    <path
      fill={color}
      d="m909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92C290 92 102.3 279.5 102 511.5C101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1c1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9c-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27c-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4c31.6-31.6 68.4-56.4 109.3-73.8c42.3-17.9 87.4-27 133.8-27c46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
    />
  </svg>
);

export const IconFullScreen = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 7V2h5m15 5V2h-5M7 22H2v-5m15 5h5v-5"
    />
  </svg>
);

export const IconLogo = ({ color = '#069CD1', size = 22 }: any) => (
  <svg
    width={size}
    height={size * 0.27}
    viewBox="0 0 110 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.64839 30H19.4143C20.3301 30 21.0627 29.2329 21.0627 28.274V1.72603C21.0627 0.767124 20.3301 0 19.4143 0H1.64839C0.732617 0 0 0.767124 0 1.72603V28.274C0 29.2329 0.732617 30 1.64839 30Z"
      fill="#0FBABA"
    />
    <path
      d="M64.3002 1.95898V13.6165C65.5038 11.9042 67.3091 11.3425 68.9445 11.3425C70.9853 11.3425 72.8169 12.1508 74.1251 13.4384C75.5642 14.8768 76.4669 17.0138 76.4669 19.6028C76.4669 22.0138 75.6688 24.2604 74.1251 25.8631C72.8169 27.2604 71.2208 28.0001 69.0099 28.0001C66.3672 28.0001 65.0328 26.6987 64.3002 25.5891V27.4795H59.4858V1.95898H64.3002ZM65.072 16.822C64.5095 17.4521 63.9993 18.3562 63.9993 19.6987C63.9993 21.0001 64.5357 21.9453 65.0982 22.4932C65.8701 23.2604 66.9428 23.6439 67.8455 23.6439C68.6828 23.6439 69.6117 23.2878 70.3574 22.5617C71.0638 21.8631 71.5217 20.8494 71.5217 19.6987C71.5217 18.4384 71.0507 17.4247 70.3574 16.7261C69.5855 15.959 68.7482 15.6713 67.7801 15.6713C66.7466 15.6713 65.8439 15.9864 65.072 16.822Z"
      fill="#2E294E"
    />
    <path
      d="M84.421 16.4384V27.9864H79.6067V16.4384H77.9321V12.3836H79.6067V7.34253H84.421V12.3836H87.3907V16.4384H84.421Z"
      fill="#2E294E"
    />
    <path
      d="M98.6023 15.8492C97.8697 15.3971 96.9016 14.9725 95.9596 14.9725C95.4625 14.9725 94.8869 15.1095 94.586 15.4245C94.4159 15.6026 94.2851 15.8766 94.2851 16.1232C94.2851 16.4793 94.5206 16.6848 94.7561 16.8218C95.0962 17.0273 95.5933 17.1369 96.1951 17.3423L97.4641 17.767C98.3014 18.041 99.1648 18.3971 99.9367 19.1369C100.8 19.9725 101.101 20.9177 101.101 22.1095C101.101 24.178 100.238 25.5067 99.5573 26.2054C98.0921 27.7396 96.2867 27.9862 94.7168 27.9862C92.7152 27.9862 90.5435 27.5341 88.5942 25.7396L90.6351 22.3423C91.1061 22.767 91.7733 23.2464 92.2704 23.493C92.9376 23.8492 93.644 23.9862 94.272 23.9862C94.5729 23.9862 95.3448 23.9862 95.7765 23.63C96.0774 23.3834 96.2736 22.9999 96.2736 22.6163C96.2736 22.3423 96.169 21.9862 95.7372 21.7122C95.3971 21.5067 94.9654 21.356 94.272 21.1506L93.0684 20.767C92.205 20.493 91.3023 19.9999 90.6613 19.3286C89.9548 18.5615 89.5885 17.6848 89.5885 16.493C89.5885 14.9862 90.151 13.7259 91.0276 12.8903C92.362 11.5889 94.1673 11.3149 95.541 11.3149C97.7519 11.3149 99.2826 11.904 100.486 12.6437L98.6023 15.8492Z"
      fill="#2E294E"
    />
    <path
      d="M18.7471 27.4658H13.9328V25.5754C13.2002 26.6987 11.8658 27.9864 9.22311 27.9864C7.01217 27.9864 5.41611 27.2467 4.10787 25.8494C2.57722 24.2467 1.76611 22.0138 1.76611 19.5891C1.76611 17.0001 2.6688 14.8631 4.10787 13.4247C5.41611 12.1234 7.24766 11.3288 9.28852 11.3288C10.9238 11.3288 12.7292 11.8905 13.9328 13.6028V1.95898H18.7471V27.4658ZM7.8887 16.7261C7.18224 17.4247 6.72436 18.4384 6.72436 19.6987C6.72436 20.8494 7.19533 21.8631 7.8887 22.5617C8.62131 23.3015 9.56325 23.6439 10.4005 23.6439C11.3032 23.6439 12.376 23.2604 13.1348 22.4932C13.6973 21.9316 14.2337 20.9864 14.2337 19.6987C14.2337 18.3699 13.7365 17.4521 13.1609 16.822C12.3891 15.9864 11.4864 15.6713 10.4529 15.6713C9.48475 15.6713 8.66056 15.959 7.8887 16.7261Z"
      fill="white"
    />
    <path
      d="M38.1613 25.4656C36.8269 26.8629 34.5505 27.9861 31.6462 27.9861C28.7419 27.9861 26.4656 26.8629 25.1311 25.4656C23.6267 23.8903 22.894 21.6574 22.894 19.6574C22.894 17.6574 23.6267 15.4245 25.1311 13.8492C26.4656 12.4519 28.7419 11.3286 31.6462 11.3286C34.5505 11.3286 36.8269 12.4519 38.1613 13.8492C39.6657 15.4245 40.3984 17.6574 40.3984 19.6574C40.3984 21.6574 39.6657 23.8903 38.1613 25.4656ZM28.9381 16.7259C28.2317 17.4656 27.8392 18.4108 27.8392 19.6711C27.8392 21.1094 28.3756 22.0135 28.9381 22.6163C29.5399 23.2464 30.4034 23.7396 31.6724 23.7396C32.7451 23.7396 33.6478 23.356 34.3412 22.6163C35.0476 21.8766 35.4401 20.9314 35.4401 19.6711C35.4401 18.4108 35.0346 17.4656 34.3412 16.7259C33.6347 15.9861 32.732 15.6026 31.6331 15.6026C30.5342 15.6026 29.6315 15.9861 28.9381 16.7259Z"
      fill="#2E294E"
    />
    <path
      d="M46.9921 11.863V20.4658C46.9921 21.1644 47.0575 22.2466 47.8294 22.9863C48.1695 23.3014 48.7713 23.7261 49.831 23.7261C50.7337 23.7261 51.4401 23.411 51.8718 22.9863C52.5783 22.2877 52.6699 21.2329 52.6699 20.4658V11.863H57.4842V20.9589C57.4842 22.7398 57.3141 24.4247 55.8097 25.9589C54.1089 27.7124 51.5971 27.9863 49.831 27.9863C47.9863 27.9863 45.5138 27.7124 43.813 25.9589C42.4394 24.5617 42.1777 22.9863 42.1777 21.274V11.863H46.9921Z"
      fill="#2E294E"
    />
    <path
      d="M106.295 27.9863C108.065 27.9863 109.5 26.4837 109.5 24.6301C109.5 22.7765 108.065 21.2739 106.295 21.2739C104.525 21.2739 103.09 22.7765 103.09 24.6301C103.09 26.4837 104.525 27.9863 106.295 27.9863Z"
      fill="#0FBABA"
    />
  </svg>
);

export const IconClips = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9497 16.6066L9.53553 18.0208C7.58291 19.9734 4.41709 19.9734 2.46447 18.0208C0.511844 16.0682 0.511845 12.9024 2.46447 10.9497L3.87868 9.53553M16.6066 10.9497L18.0208 9.53553C19.9734 7.58291 19.9734 4.41709 18.0208 2.46447C16.0682 0.511844 12.9024 0.511845 10.9497 2.46447L9.53553 3.87868M6.74264 13.7426L13.7426 6.74262"
      stroke="#7D7D7D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCorrect = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 48 48"
  >
    <mask id="svgIDa">
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="m4 24l5-5l10 10L39 9l5 5l-25 25L4 24Z"
        clipRule="evenodd"
      />
    </mask>
    <path fill={color} d="M0 0h48v48H0z" mask="url(#svgIDa)" />
  </svg>
);

export const IconEmail = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Zm-2.2 2L16 14.78L6.2 8ZM4 24V8.91l11.43 7.91a1 1 0 0 0 1.14 0L28 8.91V24Z"
    />
  </svg>
);

export const IConCaixaEntrada = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9H4.88197C5.56717 9 6.19357 9.38713 6.5 10C6.80643 10.6129 7.43283 11 8.11803 11H13.882C14.5672 11 15.1936 10.6129 15.5 10C15.8064 9.38713 16.4328 9 17.118 9H20.5M7.96656 1H14.0334C15.1103 1 15.6487 1 16.1241 1.16396C16.5445 1.30896 16.9274 1.5456 17.2451 1.85675C17.6043 2.2086 17.8451 2.6902 18.3267 3.65337L20.4932 7.9865C20.6822 8.36449 20.7767 8.55348 20.8434 8.75155C20.9026 8.92745 20.9453 9.10847 20.971 9.29226C21 9.49923 21 9.71053 21 10.1331V12.2C21 13.8802 21 14.7202 20.673 15.362C20.3854 15.9265 19.9265 16.3854 19.362 16.673C18.7202 17 17.8802 17 16.2 17H5.8C4.11984 17 3.27976 17 2.63803 16.673C2.07354 16.3854 1.6146 15.9265 1.32698 15.362C1 14.7202 1 13.8802 1 12.2V10.1331C1 9.71053 1 9.49923 1.02897 9.29226C1.05471 9.10847 1.09744 8.92745 1.15662 8.75155C1.22326 8.55348 1.31776 8.36448 1.50675 7.9865L3.67331 3.65337C4.1549 2.69019 4.3957 2.2086 4.75495 1.85675C5.07263 1.5456 5.45551 1.30896 5.87589 1.16396C6.35125 1 6.88969 1 7.96656 1Z"
      stroke="#7D7D7D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IConCaixaSaida = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15375 10H3.65375M3.56909 10.2915L1.23417 17.2662C1.05074 17.8142 0.95902 18.0881 1.02484 18.2569C1.082 18.4034 1.20476 18.5145 1.35625 18.5567C1.53068 18.6054 1.79415 18.4869 2.32108 18.2497L19.0325 10.7296C19.5469 10.4981 19.804 10.3824 19.8835 10.2216C19.9526 10.082 19.9526 9.9181 19.8835 9.77843C19.804 9.61767 19.5469 9.50195 19.0325 9.2705L2.31525 1.74776C1.78991 1.51135 1.52724 1.39315 1.35298 1.44164C1.20164 1.48375 1.07889 1.59454 1.02153 1.74078C0.955484 1.90917 1.04622 2.18255 1.22769 2.72931L3.56974 9.78556C3.60091 9.87947 3.61649 9.92642 3.62265 9.97444C3.62811 10.0171 3.62805 10.0602 3.62248 10.1028C3.61621 10.1508 3.6005 10.1977 3.56909 10.2915Z"
      stroke="#7D7D7D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconReload2 = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 8 8"
  >
    <path
      fill="currentColor"
      d="M4 0C1.8 0 0 1.8 0 4s1.8 4 4 4c1.1 0 2.12-.43 2.84-1.16l-.72-.72c-.54.54-1.29.88-2.13.88c-1.66 0-3-1.34-3-3s1.34-3 3-3c.83 0 1.55.36 2.09.91L4.99 3h3V0L6.8 1.19C6.08.47 5.09 0 3.99 0z"
    />
  </svg>
);

export const IconEstrela = ({ color = '#fff', size = 19 }: any) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.81426 0.131603C9.18229 -0.0438676 9.60985 -0.0438676 9.97787 0.131603C10.296 0.283294 10.4714 0.546668 10.5599 0.691155C10.6513 0.840528 10.7452 1.03081 10.8367 1.21628C10.8414 1.22575 10.8461 1.23521 10.8507 1.24465L12.7795 5.1522L17.1253 5.78739C17.3299 5.81725 17.5398 5.84789 17.71 5.88883C17.8748 5.92844 18.1793 6.0141 18.4216 6.26991C18.702 6.56584 18.8339 6.97249 18.7805 7.37663C18.7343 7.72598 18.538 7.97404 18.4279 8.10276C18.3141 8.23581 18.1621 8.38378 18.014 8.52799L14.8706 11.5896L15.6123 15.9139C15.6473 16.1178 15.6832 16.327 15.6971 16.5017C15.7104 16.6706 15.7234 16.9868 15.5551 17.2966C15.3605 17.6549 15.0145 17.9062 14.6136 17.9805C14.267 18.0448 13.9702 17.9347 13.8137 17.8698C13.6519 17.8027 13.4641 17.7038 13.281 17.6075L9.39607 15.5645L5.51116 17.6075C5.32806 17.7038 5.14023 17.8027 4.97842 17.8698C4.82193 17.9347 4.52517 18.0448 4.17855 17.9805C3.77762 17.9062 3.43166 17.6549 3.23703 17.2966C3.06877 16.9868 3.0817 16.6706 3.09507 16.5017C3.1089 16.327 3.14482 16.1178 3.17984 15.9139L3.92151 11.5896L0.800848 8.55007C0.793315 8.54274 0.785766 8.53539 0.778207 8.52803C0.630076 8.38381 0.478082 8.23582 0.36424 8.10276C0.254109 7.97404 0.0577811 7.72598 0.0116463 7.37663C-0.0417252 6.97249 0.0901273 6.56584 0.370493 6.26991C0.612844 6.0141 0.917379 5.92844 1.08209 5.88883C1.25235 5.84789 1.46226 5.81725 1.66683 5.78739C1.67727 5.78587 1.6877 5.78435 1.6981 5.78282L6.01261 5.1522L7.94141 1.24465C7.94607 1.23521 7.95074 1.22575 7.95541 1.21628C8.04691 1.03081 8.14079 0.840528 8.23224 0.691155C8.3207 0.546668 8.49611 0.283294 8.81426 0.131603ZM5.91941 5.3388C5.91928 5.33902 5.91928 5.33902 5.91941 5.3388V5.3388ZM6.21884 5.12107C6.21909 5.12102 6.21909 5.12101 6.21884 5.12107V5.12107ZM14.8363 11.3835C14.8362 11.3833 14.8362 11.3833 14.8363 11.3835V11.3835ZM9.39607 2.3699L7.58699 6.03489C7.58353 6.0419 7.57959 6.05006 7.57516 6.05923C7.53222 6.14814 7.4433 6.33223 7.3023 6.484C7.18327 6.61211 7.04052 6.7159 6.88196 6.78964C6.69411 6.87699 6.49158 6.90482 6.39376 6.91827C6.38367 6.91965 6.37469 6.92089 6.36696 6.92202L2.31997 7.51355L5.24707 10.3645C5.25267 10.37 5.25923 10.3763 5.2666 10.3833C5.33802 10.4517 5.4859 10.5933 5.58682 10.7745C5.672 10.9275 5.72665 11.0956 5.74773 11.2694C5.7727 11.4754 5.73636 11.6769 5.71881 11.7742C5.717 11.7842 5.71539 11.7931 5.71406 11.8009L5.02345 15.8275L8.641 13.925C8.64793 13.9214 8.65593 13.9171 8.66492 13.9123C8.75202 13.8655 8.93237 13.7687 9.1359 13.7288C9.30771 13.6951 9.48442 13.6951 9.65623 13.7288C9.85977 13.7687 10.0401 13.8655 10.1272 13.9123C10.1362 13.9171 10.1442 13.9214 10.1511 13.925L13.7687 15.8275L13.0781 11.8009C13.0767 11.7931 13.0751 11.7842 13.0733 11.7742C13.0558 11.6769 13.0194 11.4754 13.0444 11.2694C13.0655 11.0956 13.1201 10.9275 13.2053 10.7745C13.3062 10.5933 13.4541 10.4517 13.5255 10.3833C13.5329 10.3763 13.5395 10.37 13.5451 10.3645L16.4722 7.51355L12.4252 6.92202C12.4174 6.92089 12.4085 6.91965 12.3984 6.91827C12.3006 6.90482 12.098 6.87699 11.9102 6.78964C11.7516 6.7159 11.6089 6.61211 11.4898 6.484C11.3488 6.33223 11.2599 6.14814 11.217 6.05924C11.2125 6.05006 11.2086 6.0419 11.2051 6.03489L9.39607 2.3699Z"
      fill={color}
    />
  </svg>
);
export const IconConvites = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.52333 9C1.52333 4.02944 5.55276 0 10.5233 0C15.4939 0 19.5233 4.02944 19.5233 9C19.5233 13.9706 15.4939 18 10.5233 18C9.38494 18 8.29379 17.7882 7.28869 17.401C7.20252 17.3678 7.15261 17.3486 7.1158 17.3354C7.1113 17.3337 7.1074 17.3324 7.10408 17.3312C7.10288 17.3313 7.1016 17.3314 7.10022 17.3315C7.07027 17.3338 7.02938 17.338 6.95117 17.346L2.09967 17.8475C2.089 17.8486 2.0783 17.8498 2.06758 17.8509C1.86466 17.8719 1.65297 17.8938 1.47592 17.8959C1.29995 17.8979 0.982783 17.888 0.678671 17.7025C0.322194 17.485 0.0793965 17.1218 0.0147657 16.7093C-0.0403713 16.3573 0.071686 16.0605 0.140868 15.8986C0.210473 15.7358 0.311668 15.5486 0.40867 15.3692L1.9736 12.4726C2.04129 12.3473 2.07748 12.2798 2.10183 12.2296C2.10311 12.227 2.1043 12.2245 2.10539 12.2222C2.10356 12.2156 2.10135 12.2079 2.09867 12.1988C2.07816 12.1294 2.0466 12.0353 1.99299 11.8762C1.68816 10.9719 1.52333 10.0042 1.52333 9ZM10.5233 1.89474C6.5992 1.89474 3.41806 5.07587 3.41806 9C3.41806 9.79578 3.54852 10.5591 3.78847 11.271C3.7961 11.2937 3.80396 11.3168 3.81197 11.3403C3.88885 11.5663 3.97914 11.8317 3.99815 12.0719C4.01547 12.2908 3.99968 12.4758 3.94552 12.6887C3.88629 12.9214 3.76591 13.1427 3.66827 13.3222C3.65881 13.3396 3.64956 13.3566 3.6406 13.3732L2.26143 15.926L6.75635 15.4614C6.76654 15.4603 6.77701 15.4592 6.78772 15.4581C6.90046 15.4462 7.04017 15.4316 7.17729 15.4368C7.30261 15.4416 7.40821 15.4557 7.53041 15.4838C7.66456 15.5147 7.81009 15.5711 7.93283 15.6186C7.94542 15.6235 7.95777 15.6282 7.96984 15.6329C8.76105 15.9377 9.6215 16.1053 10.5233 16.1053C14.4475 16.1053 17.6286 12.9241 17.6286 9C17.6286 5.07587 14.4475 1.89474 10.5233 1.89474ZM14.509 5.96169C14.879 6.33166 14.879 6.9315 14.509 7.30147L10.2458 11.5646C9.87588 11.9346 9.27604 11.9346 8.90607 11.5646L7.01133 9.66989C6.64136 9.29992 6.64136 8.70008 7.01133 8.33011C7.3813 7.96014 7.98114 7.96014 8.35111 8.33011L9.57596 9.55496L13.1692 5.96169C13.5392 5.59172 14.139 5.59172 14.509 5.96169Z"
      fill="white"
    />
  </svg>
);

export const IconConversas = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.27271 7.36363C3.27271 3.29176 6.59386 0 10.6794 0C14.7649 0 18.0861 3.29176 18.0861 7.36363C18.0861 8.28152 17.9168 9.16192 17.6068 9.97439C17.5769 10.0528 17.5595 10.0987 17.5475 10.1325C17.5459 10.1369 17.5446 10.1406 17.5435 10.1438C17.5436 10.1449 17.5437 10.1461 17.5439 10.1474C17.5464 10.1744 17.5509 10.2112 17.5596 10.2814L17.8917 12.9798C17.9071 13.1042 17.9245 13.2454 17.9287 13.3683C17.9333 13.5044 17.9276 13.7156 17.8262 13.9372C17.6995 14.2139 17.4746 14.4337 17.195 14.5539C16.9711 14.6502 16.7599 14.6511 16.624 14.6433C16.5012 14.6363 16.3604 14.6157 16.2363 14.5974C16.2287 14.5963 16.2211 14.5952 16.2137 14.5941L13.6075 14.2121C13.5351 14.2015 13.4971 14.196 13.4692 14.1927C13.4679 14.1925 13.4666 14.1924 13.4655 14.1922C13.4622 14.1933 13.4584 14.1946 13.4539 14.1962C13.419 14.2084 13.3715 14.2261 13.2903 14.2565C12.4772 14.5611 11.5968 14.7273 10.6794 14.7273C10.5325 14.7273 10.3865 14.723 10.2415 14.7146C9.46178 16.6362 7.60918 18 5.42585 18C4.8305 18 4.25698 17.8977 3.72229 17.709C3.63392 17.6778 3.57911 17.6585 3.5389 17.6452C3.53161 17.6428 3.52563 17.6409 3.52085 17.6394C3.51948 17.6395 3.51801 17.6397 3.51641 17.6399C3.48835 17.643 3.4501 17.6481 3.3792 17.6578L0.928905 17.9925C0.663769 18.0287 0.397683 17.9329 0.21639 17.7361C0.0350977 17.5393 -0.0384863 17.2662 0.0193504 17.005L0.519541 14.7454C0.536921 14.6669 0.546222 14.6245 0.552196 14.5934C0.552534 14.5916 0.552845 14.59 0.553127 14.5884C0.551641 14.5833 0.549758 14.5769 0.547405 14.5691C0.533932 14.5244 0.514117 14.4636 0.481907 14.365C0.308711 13.8348 0.215323 13.2686 0.215323 12.6818C0.215323 10.5332 1.46977 8.66566 3.28735 7.82997C3.27763 7.67568 3.27271 7.52018 3.27271 7.36363ZM4.90913 7.38935C5.079 7.37234 5.25137 7.36363 5.42585 7.36363C8.3221 7.36363 10.6364 9.76345 10.6364 12.6818C10.6364 12.8193 10.6312 12.9556 10.6211 13.0906C10.6405 13.0908 10.66 13.0909 10.6794 13.0909C11.398 13.0909 12.0841 12.9609 12.7164 12.7241C12.7278 12.7198 12.7395 12.7154 12.7514 12.7109C12.867 12.6674 13.0035 12.616 13.1281 12.5898C13.2419 12.5659 13.3392 12.5555 13.4555 12.5548C13.5824 12.5541 13.7115 12.5733 13.8158 12.5887C13.8257 12.5902 13.8354 12.5916 13.8449 12.593L16.2386 12.9439L15.9354 10.4813C15.9343 10.4721 15.9331 10.4627 15.9319 10.4531C15.9193 10.352 15.9037 10.227 15.9066 10.1044C15.9093 9.99197 15.9206 9.89834 15.945 9.78855C15.9717 9.66844 16.0222 9.53675 16.065 9.4251C16.0694 9.41356 16.0737 9.40223 16.078 9.39116C16.318 8.7619 16.4497 8.07896 16.4497 7.36363C16.4497 4.2056 13.8713 1.63636 10.6794 1.63636C7.48747 1.63636 4.90907 4.2056 4.90907 7.36363C4.90907 7.37221 4.90909 7.38078 4.90913 7.38935ZM8.88613 13.609C8.96041 13.3134 9.00001 13.0028 9.00001 12.6818C9.00001 10.6296 7.38124 9 5.42585 9C3.47045 9 1.85169 10.6296 1.85169 12.6818C1.85169 13.0942 1.91722 13.4891 2.03738 13.8569C2.04214 13.8715 2.04703 13.8863 2.05199 13.9014C2.09801 14.0415 2.15016 14.2002 2.17111 14.3336C2.19076 14.4589 2.19549 14.5553 2.18817 14.6818C2.1804 14.8161 2.14954 14.9543 2.12438 15.067C2.12193 15.0779 2.11954 15.0886 2.11723 15.0991L1.8708 16.2123L3.15777 16.0365C3.1672 16.0352 3.17688 16.0339 3.18677 16.0325C3.28854 16.0184 3.41333 16.0012 3.53304 16.002C3.64638 16.0028 3.73072 16.0114 3.84188 16.0335C3.95979 16.0571 4.10123 16.1072 4.22674 16.1517C4.24033 16.1566 4.25373 16.1613 4.2669 16.166C4.62947 16.2939 5.01897 16.3636 5.42585 16.3636C7.06187 16.3636 8.46224 15.2229 8.87605 13.6483C8.8791 13.6351 8.88246 13.622 8.88613 13.609Z"
      fill="white"
    />
  </svg>
);

export const IconEstrelaAmarela = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75378 1.34164C8.99326 0.604592 10.036 0.604592 10.2755 1.34164L11.8172 6.08653C11.9243 6.41615 12.2314 6.63932 12.578 6.63932H17.5671C18.3421 6.63932 18.6643 7.63101 18.0373 8.08653L14.0011 11.019C13.7207 11.2228 13.6034 11.5838 13.7105 11.9135L15.2522 16.6584C15.4917 17.3954 14.6481 18.0083 14.0211 17.5528L9.98485 14.6203C9.70446 14.4166 9.32478 14.4166 9.04439 14.6203L5.00815 17.5528C4.38118 18.0083 3.53759 17.3954 3.77707 16.6584L5.31878 11.9135C5.42588 11.5838 5.30856 11.2228 5.02817 11.019L0.991918 8.08653C0.364948 7.63101 0.687168 6.63932 1.46215 6.63932H6.45122C6.7978 6.63932 7.10497 6.41615 7.21207 6.08653L8.75378 1.34164Z"
      fill="#FAAE42"
    />
  </svg>
);

export const IconExtrelaFavorito = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75378 1.34164C8.99326 0.604592 10.036 0.604592 10.2755 1.34164L11.8172 6.08653C11.9243 6.41615 12.2314 6.63932 12.578 6.63932H17.5671C18.3421 6.63932 18.6643 7.63101 18.0373 8.08653L14.0011 11.019C13.7207 11.2228 13.6034 11.5838 13.7105 11.9135L15.2522 16.6584C15.4917 17.3954 14.6481 18.0083 14.0211 17.5528L9.98485 14.6203C9.70446 14.4166 9.32478 14.4166 9.04439 14.6203L5.00815 17.5528C4.38118 18.0083 3.53759 17.3954 3.77707 16.6584L5.31878 11.9135C5.42588 11.5838 5.30856 11.2228 5.02817 11.019L0.991918 8.08653C0.364948 7.63101 0.687168 6.63932 1.46215 6.63932H6.45122C6.7978 6.63932 7.10497 6.41615 7.21207 6.08653L8.75378 1.34164Z"
      fill="#E7E7F3"
    />
  </svg>
);

export const IconExtrelaFavoritoBorderWhite = ({
  color = '#069CD1',
  size = 19,
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 36 36"
  >
    <path
      fill="var(--texto)"
      d="M27.19 34a2.22 2.22 0 0 1-1.24-.38l-7.46-5a.22.22 0 0 0-.25 0l-7.46 5a2.22 2.22 0 0 1-3.38-2.41l2.45-8.64a.23.23 0 0 0-.08-.24l-7.06-5.55a2.22 2.22 0 0 1 1.29-4l9-.34a.23.23 0 0 0 .2-.15l3.1-8.43a2.22 2.22 0 0 1 4.17 0l3.1 8.43a.23.23 0 0 0 .2.15l9 .34a2.22 2.22 0 0 1 1.29 4L27 22.33a.22.22 0 0 0-.08.24l2.45 8.64A2.23 2.23 0 0 1 27.19 34Zm-8.82-7.42a2.21 2.21 0 0 1 1.23.42l7.46 5a.22.22 0 0 0 .34-.25l-2.45-8.64a2.21 2.21 0 0 1 .77-2.35l7.06-5.55a.22.22 0 0 0-.13-.4l-9-.34a2.22 2.22 0 0 1-2-1.46l-3.1-8.43a.22.22 0 0 0-.42 0L15.06 13a2.22 2.22 0 0 1-2 1.46l-9 .34a.22.22 0 0 0-.13.4L11 20.76a2.22 2.22 0 0 1 .77 2.35l-2.44 8.64a.21.21 0 0 0 .08.24a.2.2 0 0 0 .26 0l7.46-5a2.22 2.22 0 0 1 1.23-.37Z"
    />
    <path fill="none" d="M0 0h36v36H0z" />
  </svg>
);

export const IconCases = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 14C19.433 14 21 11.0899 21 7.5C21 3.91015 19.433 1 17.5 1M17.5 14C15.567 14 14 11.0899 14 7.5C14 3.91015 15.567 1 17.5 1M17.5 14L4.44354 11.6261C3.51605 11.4575 3.05231 11.3731 2.67733 11.189C1.91447 10.8142 1.34636 10.1335 1.11414 9.31593C1 8.91405 1 8.4427 1 7.5C1 6.5573 1 6.08595 1.11414 5.68407C1.34636 4.86649 1.91447 4.18577 2.67733 3.81105C3.05231 3.62685 3.51605 3.54254 4.44354 3.3739L17.5 1M4 12L4.39386 17.514C4.43126 18.0376 4.44996 18.2995 4.56387 18.4979C4.66417 18.6726 4.81489 18.8129 4.99629 18.9005C5.20232 19 5.46481 19 5.98979 19H7.7722C8.37234 19 8.67242 19 8.89451 18.8803C9.08966 18.7751 9.24434 18.6081 9.33423 18.4055C9.43653 18.1749 9.41351 17.8757 9.36748 17.2773L9 12.5"
      stroke="#069CD1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSelo = ({ color = '#069CD1', size = 19 }: any) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11L10 13L14.5 8.5M16.9012 3.99851C17.1071 4.49653 17.5024 4.8924 18.0001 5.09907L19.7452 5.82198C20.2433 6.02828 20.639 6.42399 20.8453 6.92206C21.0516 7.42012 21.0516 7.97974 20.8453 8.47781L20.1229 10.2218C19.9165 10.7201 19.9162 11.2803 20.1236 11.7783L20.8447 13.5218C20.9469 13.7685 20.9996 14.0329 20.9996 14.2999C20.9997 14.567 20.9471 14.8314 20.8449 15.0781C20.7427 15.3249 20.5929 15.549 20.4041 15.7378C20.2152 15.9266 19.991 16.0764 19.7443 16.1785L18.0004 16.9009C17.5023 17.1068 17.1065 17.5021 16.8998 17.9998L16.1769 19.745C15.9706 20.2431 15.575 20.6388 15.0769 20.8451C14.5789 21.0514 14.0193 21.0514 13.5212 20.8451L11.7773 20.1227C11.2792 19.9169 10.7198 19.9173 10.2221 20.1239L8.47689 20.8458C7.97912 21.0516 7.42001 21.0514 6.92237 20.8453C6.42473 20.6391 6.02925 20.2439 5.82281 19.7464L5.09972 18.0006C4.8938 17.5026 4.49854 17.1067 4.00085 16.9L2.25566 16.1771C1.75783 15.9709 1.36226 15.5754 1.15588 15.0777C0.949508 14.5799 0.949228 14.0205 1.1551 13.5225L1.87746 11.7786C2.08325 11.2805 2.08283 10.7211 1.8763 10.2233L1.15497 8.47678C1.0527 8.2301 1.00004 7.96568 1 7.69863C0.999957 7.43159 1.05253 7.16715 1.15472 6.92043C1.25691 6.67372 1.40671 6.44955 1.59557 6.26075C1.78442 6.07195 2.00862 5.92222 2.25537 5.8201L3.9993 5.09772C4.49687 4.89197 4.89248 4.4972 5.0993 4.00006L5.82218 2.25481C6.02848 1.75674 6.42418 1.36103 6.92222 1.15473C7.42027 0.948424 7.97987 0.948424 8.47792 1.15473L10.2218 1.87712C10.7199 2.08291 11.2793 2.08249 11.7771 1.87595L13.523 1.15585C14.021 0.94966 14.5804 0.949702 15.0784 1.15597C15.5763 1.36223 15.972 1.75783 16.1783 2.25576L16.9014 4.00153L16.9012 3.99851Z"
      stroke="#069CD1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCampanha = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
  >
    <path
      fill={color}
      d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013a74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036c2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975l1.609 3.037l.01.024h.548l-.002-.014l-.443-2.966a68.019 68.019 0 0 0-1.722-.082z"
    />
  </svg>
);

export const IconImage = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0667 27H6.67865C5.80358 27 5.36605 27 5.16344 26.827C4.98765 26.6768 4.89435 26.4516 4.91249 26.2211C4.9334 25.9555 5.24278 25.6461 5.86155 25.0273L18.1436 12.7453C18.7156 12.1733 19.0016 11.8873 19.3314 11.7801C19.6215 11.6859 19.934 11.6859 20.2241 11.7801C20.5539 11.8873 20.84 12.1733 21.412 12.7453L27 18.3333V20.0667M20.0667 27C22.4936 27 23.707 27 24.634 26.5277C25.4493 26.1122 26.1122 25.4493 26.5277 24.634C27 23.707 27 22.4936 27 20.0667M20.0667 27H7.93333C5.50644 27 4.29299 27 3.36604 26.5277C2.55067 26.1122 1.88776 25.4493 1.47231 24.634C1 23.707 1 22.4936 1 20.0667V7.93333C1 5.50644 1 4.29299 1.47231 3.36604C1.88776 2.55067 2.55067 1.88776 3.36604 1.47231C4.29299 1 5.50644 1 7.93333 1H20.0667C22.4936 1 23.707 1 24.634 1.47231C25.4493 1.88776 26.1122 2.55067 26.5277 3.36604C27 4.29299 27 5.50644 27 7.93333V20.0667M11.8333 8.94444C11.8333 10.5399 10.5399 11.8333 8.94444 11.8333C7.34896 11.8333 6.05556 10.5399 6.05556 8.94444C6.05556 7.34896 7.34896 6.05556 8.94444 6.05556C10.5399 6.05556 11.8333 7.34896 11.8333 8.94444Z"
      stroke="#0661C7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconVolume = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M6 15q-.425 0-.713-.288Q5 14.425 5 14v-4q0-.425.287-.713Q5.575 9 6 9h3l3.3-3.3q.475-.475 1.087-.213q.613.263.613.938v11.15q0 .675-.613.937q-.612.263-1.087-.212L9 15Zm10 1V7.95q1.125.525 1.812 1.625q.688 1.1.688 2.425q0 1.325-.688 2.4Q17.125 15.475 16 16Z"
    />
  </svg>
);

export const IconCoin = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 72 72"
  >
    <ellipse
      cx="34.153"
      cy="34.635"
      fill="#fcea2b"
      rx="29.033"
      ry="22.118"
      transform="rotate(-51.131 34.153 34.635)"
    />
    <path
      fill="#fff"
      d="M52.139 12.03a18.698 18.698 0 0 0-13.3-3.86a17.98 17.98 0 0 1 10.077 3.86c9.51 7.666 9.064 24-.998 36.484c-6.14 7.618-14.44 12.034-22.14 12.584c8.53.639 18.353-3.889 25.362-12.584c10.062-12.484 10.51-28.819.999-36.484Z"
    />
    <path
      fill="#f1b31c"
      d="M55.349 13.082a20.374 20.374 0 0 0-1.558-1.138a.928.928 0 0 0-.11-.045a1.03 1.03 0 0 0-.556-.102a.923.923 0 0 0-.527.235a.943.943 0 0 0-.094.069c-.019.02-.025.047-.042.068s-.041.034-.057.057a.945.945 0 0 0-.044.11a1.027 1.027 0 0 0-.102.562a.978.978 0 0 0 .043.183a.834.834 0 0 0 .19.336a.941.941 0 0 0 .07.097c8.278 7.636 7.415 22.736-1.965 34.375c-9.702 12.035-24.97 15.88-34.034 8.573a.96.96 0 0 0-.187-.097l-.055-.029a.97.97 0 0 0-.3-.074c-.027-.002-.053-.006-.08-.007a.916.916 0 0 0-.59.196a.94.94 0 0 0-.098.058c-.02.017-.027.041-.044.06c-.016.017-.038.025-.053.043a.935.935 0 0 0-.047.091a.96.96 0 0 0-.117.226a.934.934 0 0 0-.024.097a.972.972 0 0 0-.026.297c.002.02.006.038.009.058a.965.965 0 0 0 .096.312c.008.016.018.03.027.045a.953.953 0 0 0 .109.183a20.069 20.069 0 0 0 2.286 2.158a21.13 21.13 0 0 0 13.441 4.555c8.59 0 17.89-4.48 24.528-12.715c10.444-12.957 10.403-30.38-.09-38.837Z"
    />
    <path
      fill="#f1b31c"
      d="M20.652 44.72c.073-.232.61-2.214.681-2.446c5.918.106 6.21-.091 7.089-3.008c1.66-5.508 2.144-6.494 3.805-12.002c.583-1.932.48-2.354-2.29-2.882l-1.687-.311c.063-.204.441-2.075.504-2.278a94.249 94.249 0 0 0 12.214-.789l-5.499 19c-.858 2.966-.752 3.204 4.93 4.302c-.066.234-.6 2.218-.665 2.453Z"
    />
    <g fill="none" stroke="#000" strokeWidth="2">
      <path
        stroke-miterlimit="10"
        d="M53.237 12.777q.762.501 1.483 1.082c10.08 8.124 10.052 24.883-.061 37.43S28.175 67.424 18.095 59.3a19.09 19.09 0 0 1-2.172-2.05"
      />
      <ellipse
        cx="34.153"
        cy="34.635"
        stroke-miterlimit="10"
        rx="29.033"
        ry="22.118"
        transform="rotate(-51.131 34.153 34.635)"
      />
      <path
        stroke-miterlimit="10"
        d="m51.373 48.515l3.286 2.775m-6.743.97l2.896 3.113m-6.555-.069l2.378 3.322m-6.392-.644l1.872 3.344m11.921-16.551l3.489 2.414"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.652 44.72c.073-.232.61-2.214.681-2.446c5.918.106 6.21-.091 7.089-3.008c1.66-5.508 2.144-6.494 3.805-12.002c.583-1.932.48-2.354-2.29-2.882l-1.687-.311c.063-.204.441-2.075.504-2.278a94.249 94.249 0 0 0 12.214-.789l-5.499 19c-.858 2.966-.752 3.204 4.93 4.302c-.066.234-.6 2.218-.665 2.453Z"
      />
    </g>
  </svg>
);

export const MoreIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path fill={color} d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z" />
  </svg>
);

export const FireIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M24.832 16.969c-.272-.647-.582-1.38-.883-2.285c-.79-2.369 1.734-4.953 1.758-4.977l-1.414-1.414c-.14.14-3.423 3.478-2.242 7.023c.326.978.652 1.75.938 2.43A9.381 9.381 0 0 1 24 22a6.24 6.24 0 0 1-4.19 5.293a8.52 8.52 0 0 0-2.103-8l-1.044-1.044l-.582 1.357c-1.836 4.284-4.021 6.154-5.306 6.934A5.844 5.844 0 0 1 8 22a9.624 9.624 0 0 1 .929-3.629A11.333 11.333 0 0 0 10 14v-1.778c.874.36 2 1.303 2 3.778v2.603l1.743-1.934c3.112-3.454 2.463-7.567 1.206-10.308A4.486 4.486 0 0 1 18 11h2c0-5.537-4.579-7-7-7h-2l1.2 1.599c.137.185 2.862 3.927 1.353 7.688A4.943 4.943 0 0 0 9 10H8v4a9.624 9.624 0 0 1-.929 3.629A11.333 11.333 0 0 0 6 22c0 3.848 3.823 8 10 8s10-4.152 10-8a11.377 11.377 0 0 0-1.168-5.031ZM12.835 27.526a16.499 16.499 0 0 0 4.367-5.598a6.105 6.105 0 0 1 .257 5.971A11.321 11.321 0 0 1 16 28a10.328 10.328 0 0 1-3.165-.474Z"
    />
  </svg>
);

export const MusicIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M13 11V7.5l2.2-2.21c.8-.79.95-2.05.39-3.03A2.467 2.467 0 0 0 13.45 1c-.21 0-.45.03-.64.09C11.73 1.38 11 2.38 11 3.5v3.24L7.86 9.91a5.946 5.946 0 0 0-1.25 6.43c.77 1.9 2.45 3.21 4.39 3.55v.61c0 .26-.23.5-.5.5H9v2h1.5c1.35 0 2.5-1.11 2.5-2.5V20c2.03 0 4.16-1.92 4.16-4.75c0-2.3-1.92-4.25-4.16-4.25m0-7.5c0-.23.11-.41.32-.47c.22-.06.45.03.56.23a.5.5 0 0 1-.08.61l-.8.86V3.5m-2 8c-.97.64-1.7 1.74-1.96 2.76l1.96.52v3.05a3.86 3.86 0 0 1-2.57-2.26c-.59-1.46-.27-3.12.83-4.24L11 9.5v2m2 6.5v-5.06c1.17 0 2.18 1.1 2.18 2.31C15.18 17 13.91 18 13 18Z"
    />
  </svg>
);

export const FilmIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M18 14.5V11a1 1 0 0 0-1-1h-1c2.24-1.61 2.76-4.73 1.15-7a5.02 5.02 0 0 0-6.98-1.13C9.5 2.35 8.96 3 8.6 3.73a4.985 4.985 0 0 0-6.88 1.64a5.002 5.002 0 0 0 1.64 6.88c.21.12.42.25.64.33V21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4M13 4a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2M6 6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"
    />
  </svg>
);

export const GameIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M7.51 26a5.48 5.48 0 0 1-1.44-.19A5.6 5.6 0 0 1 2.19 19l2.33-8.84a5.54 5.54 0 0 1 2.59-3.43a5.43 5.43 0 0 1 4.15-.54A5.52 5.52 0 0 1 14.7 9h2.6a5.49 5.49 0 0 1 3.44-2.81a5.43 5.43 0 0 1 4.15.54a5.57 5.57 0 0 1 2.59 3.41L29.81 19a5.6 5.6 0 0 1-3.89 6.83a5.43 5.43 0 0 1-4.15-.54a5.54 5.54 0 0 1-2.59-3.41L19 21h-6l-.23.86a5.54 5.54 0 0 1-2.59 3.41a5.46 5.46 0 0 1-2.67.73ZM9.83 8a3.49 3.49 0 0 0-1.72.46a3.6 3.6 0 0 0-1.66 2.19l-2.33 8.84a3.6 3.6 0 0 0 2.48 4.39a3.43 3.43 0 0 0 2.62-.34a3.54 3.54 0 0 0 1.66-2.19L11.5 19h9l.61 2.35a3.58 3.58 0 0 0 1.66 2.19a3.46 3.46 0 0 0 2.63.34a3.58 3.58 0 0 0 2.47-4.39l-2.33-8.84a3.55 3.55 0 0 0-1.65-2.19a3.46 3.46 0 0 0-2.63-.34a3.55 3.55 0 0 0-2.37 2.22l-.24.66h-5.3l-.24-.66a3.56 3.56 0 0 0-2.38-2.22a3.48 3.48 0 0 0-.9-.12Z"
    />
    <path fill="currentColor" d="M10 16a2 2 0 1 1 2-2a2 2 0 0 1-2 2Zm0-2Z" />
    <circle cx="22" cy="12" r="1" fill="#8A7BE8" />
    <circle cx="22" cy="16" r="1" fill="#8A7BE8" />
    <circle cx="20" cy="14" r="1" fill="#8A7BE8" />
    <circle cx="24" cy="14" r="1" fill="#8A7BE8" />
  </svg>
);

export const ClockIcon = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    width="303"
    height="285"
    viewBox="0 0 303 285"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.0073 4.58988C91.9814 7.06119 95.6373 14.7301 93.166 21.7042L30.4621 198.656C27.9908 205.63 20.3218 209.286 13.3478 206.814C6.37369 204.343 2.71779 196.674 5.1891 189.7L67.893 12.7485C70.3643 5.77448 78.0332 2.11858 85.0073 4.58988Z"
      fill="#021030"
    />
    <path
      d="M250.275 100.174L272.657 108.105L224.08 245.193L201.698 237.261C190.161 233.173 170.092 211.472 141.486 172.171L140.085 172.545C94.3949 184.648 65.733 188.791 54.0639 184.946L53.7245 184.826L31.3426 176.895L79.9205 39.8074L102.302 47.7386C113.147 51.5816 132.537 71.6215 160.458 107.854L163.072 111.255L167.244 110.258C211.749 99.6908 239.431 96.3309 250.275 100.174Z"
      stroke="#021030"
      strokeWidth="17.28"
      stroke-linejoin="round"
    />
    <path
      d="M82.3972 91.499L64.0453 140.654C60.8757 149.599 67.7779 161.352 75.8341 159.769C89.0949 158.604 95.1137 160.08 114.306 155.108C126.624 149.05 137.379 145.799 138.528 134.379C139.779 121.94 134.469 112.295 126.751 103.762C126.751 103.762 112.059 83.8451 104.944 80.9877L104.713 80.906C95.6055 77.6787 85.6149 82.4187 82.3972 91.499Z"
      fill="#F57800"
    />
    <path
      d="M290.349 77.3542C297.324 79.8256 300.979 87.4945 298.508 94.4685L235.804 271.42C233.333 278.394 225.664 282.05 218.69 279.579C211.716 277.107 208.06 269.438 210.531 262.464L273.235 85.5129C275.706 78.5388 283.375 74.8829 290.349 77.3542Z"
      fill="#021030"
    />
  </svg>
);

export const IconLive = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      d="M5.453 4.167a.726.726 0 0 0-1.027-.01A8.225 8.225 0 0 0 2 10a8.228 8.228 0 0 0 2.604 6.015a.725.725 0 0 0 1.01-.025c.316-.316.277-.819-.027-1.11A6.73 6.73 0 0 1 3.5 10c0-1.846.741-3.52 1.943-4.738c.29-.295.32-.785.01-1.095ZM7.214 5.93a.714.714 0 0 0-1.008-.016A5.733 5.733 0 0 0 4.5 10a5.73 5.73 0 0 0 1.893 4.264a.713.713 0 0 0 .983-.037c.328-.328.267-.844-.041-1.134A4.237 4.237 0 0 1 6 10c0-1.15.457-2.194 1.2-2.96c.286-.294.333-.793.014-1.111Zm5.572 0a.714.714 0 0 1 1.008-.016A5.733 5.733 0 0 1 15.5 10a5.73 5.73 0 0 1-1.893 4.264a.713.713 0 0 1-.983-.037c-.328-.328-.267-.844.041-1.134A4.237 4.237 0 0 0 14 10c0-1.15-.457-2.194-1.2-2.96c-.286-.294-.333-.793-.014-1.111Zm1.761-1.762a.726.726 0 0 1 1.027-.01A8.225 8.225 0 0 1 18 10a8.228 8.228 0 0 1-2.604 6.015a.725.725 0 0 1-1.01-.025c-.316-.316-.277-.819.028-1.11A6.73 6.73 0 0 0 16.5 10c0-1.846-.741-3.52-1.943-4.738c-.29-.295-.32-.785-.01-1.095ZM10 8.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3Z"
    />
  </svg>
);

export const IconClock = ({ color = '#069CD1', size = 18 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="M14.55 16.55L11 13V8h2v4.175l2.95 2.95l-1.4 1.425ZM11 6V4h2v2h-2Zm7 7v-2h2v2h-2Zm-7 7v-2h2v2h-2Zm-7-7v-2h2v2H4Zm8 9q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Zm0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20Zm0-8Z"
    />
  </svg>
);

export const IconWarning = ({ color = 'var(--warning)', size = 15 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    >
      <path
        stroke-dasharray="60"
        stroke-dashoffset="60"
        d="M12 3L21 20H3L12 3Z"
      >
        <animate
          fill="freeze"
          attributeName="stroke-dashoffset"
          dur="0.5s"
          values="60;0"
        />
      </path>
      <path stroke-dasharray="6" stroke-dashoffset="6" d="M12 10V14">
        <animate
          fill="freeze"
          attributeName="stroke-dashoffset"
          begin="0.6s"
          dur="0.2s"
          values="6;0"
        />
      </path>
    </g>
    <circle cx="12" cy="17" r="1" fill={color} fill-opacity="0">
      <animate
        fill="freeze"
        attributeName="fill-opacity"
        begin="0.8s"
        dur="0.4s"
        values="0;1"
      />
    </circle>
  </svg>
);

export const IconPencil = ({ color = '#069CD1', size = 15 }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 512 512"
  >
    <path
      fill={color}
      d="m410.3 231l11.3-11.3l-33.9-33.9l-62.1-62.1l-33.9-33.9l-11.3 11.3l-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l199.2-199.2l22.6-22.7zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.2 23l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7l-14.4 14.5l-22.6 22.6l-11.4 11.3l33.9 33.9l62.1 62.1l33.9 33.9l11.3-11.3l22.6-22.6l14.5-14.5c25-25 25-65.5 0-90.5l-39.3-39.4c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    />
  </svg>
);
